/**
 * @desc: This are initial bootstrapped translations for lang en.
 *        Currently flagged it as legacy Translations.
 *        In the later phase, this translations will need to parsed and created using useTranslation hook from i18next
 *        Please do not add/update translations here, use useTranslation hook from i18next
 *
 * @todo: Migrate this translations into MOBILE.json or WEB.json using useTranslation hook in an incremental manner
 */
import type { LegacyLanguageModel } from '../types';

const legacyTranslations: LegacyLanguageModel = {
  COMMON: {
    CHILD: 'Child',
    FRIEND: 'Friend',
    OTHER: 'Other',
    PARENT: 'Parent',
    SPOUSE: 'Spouse',
    UNKNOWN_RELATION: 'Unknown relation',
    UNRECOGNIZED: 'Unrecognized',
    REMOVE: 'Remove',
    REVERT: 'Revert',
    EDIT_SEARCH: 'Edit search',
    PAYMENT: 'Payment',
    DELAYED_INVOICING: 'Delayed invoicing',
    PAID: 'Paid',
    TMC_CARD: 'TMC Card',
    TF_PAY: 'TF Pay',
    CHEQUE_OR_WIRE: 'Check or Wire',
    COMPANY_CREDIT_CARD: 'Company credit card',
    PAYMENT_OPTIONS: 'Payment Options',
    BILLED_TO_COMPANY: 'Billed to company',
    CHARGED_VIA_DELAYED_INVOICING: '{{pnrType, capitalize}} will be charged via delayed invoicing',
    CHARGING_METHOD: 'Charging Method',
    DONT_WORRY_ABOUT_THIS: "Don't worry about this.",
    PERSONAL_TRIP_OOP_LABEL: 'You are looking at search results for a personal trip.',
    PERSONAL_TRIP_CONFIRMATION_TITLE: 'Are you sure you want to deselect personal booking option?',
    PERSONAL_TRIP_CONFIRMATION_SUBTITLE:
      'By deselecting personal booking option, you will be booking a new work trip as {{email}}',
    CORPORATE_TRIP_CONFIRMATION_TITLE: 'Are you sure you want to select personal booking option?',
    CORPORATE_TRIP_CONFIRMATION_SUBTITLE:
      'By selecting personal booking option, you will be booking a new personal trip as {{email}}',
    RATE: 'Rate',
    HISTORY: 'History',
    CLICK_TO_REFRESH: 'New items',
    CLICK_TO_VIEW: 'Click here to view',
    TRAVEL_POLICY_ADVISORY: 'Before booking please go ahead and read the',
    COMPANY_POLICY: '{{company}} Travel Policy',
    VIEW_COMPANY_POLICY: 'View travel policy',
    OK: 'Ok',
    FOR: 'For',
    DEFAULT: 'Default',
    SET_DEFAULT: 'Set as default',
    CONFIRM_ACTION: 'Are you sure you want to {{action, lowercase}} {{item}}?',
    DEFAULT_ITEM_UNDONE_ACTION: 'Default {{item}} can not be {{action, lowercase}}.',
    DEFAULT_ITEM_UNDONE_ACTION_SUBTITLE: 'To {{action, lowercase}} default {{item}}, make another {{item}} as default.',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    ENABLE: 'Enable',
    DISABLE: 'Disable',
    APPLICABLE_TO: 'Applicable to',
    CODE: 'Code',
    CURRENCY: 'Currency',
    QUEUE: 'Queue',
    PCC_LABEL: 'PCC Label',
    // ToDo Airat or Bhavan: reuse everywhere from common ns
    UNDONE_ACTION: 'This action cannot be undone.',
    /**
     * Valid formats maintained here: type ValidFormats in packages/obt/common/src/translations/index.ts
     */
    LOCALIZED_NUMBER: '{{value, number}}',
    LOCALIZED_DISTANCE: '{{value, distance}}',
    LOCALIZED_CURRENCY: '{{value, currency}}',
    LOCALIZED_DATETIME: '{{value, datetime}}',
    SIGN_IN: 'Sign in',
    LOGOUT: 'Sign out',
    HEY: 'Hey',
    HAPPY_BIRTHDAY: 'Happy Birthday',
    PREFERRED: 'Preferred',
    HOME_TAGLINE: 'it’s a perfect day to plan a trip',
    BOOKING_FOR: 'you are booking for',
    FLIGHTS: 'Flights',
    TRIP: 'Trips',
    PROGRAM: 'Program',
    SETTINGS: 'Settings',
    TMC_SETTING: 'TMC Setting',
    COMPANY: 'Company',
    USERS: 'Users',
    USER: 'User',
    ANALYTICS: 'Analytics',
    ANALYTICS_DASHBOARD: 'Dashboard',
    POLICIES: 'Policies',
    REPORTS: 'Reports',
    HOME: 'Home',
    HOTELS: 'Hotels',
    CARS: 'Cars',
    CAR: 'Car',
    AIR: 'Air',
    HOTEL: 'Hotel',
    REPORT_ISSUE: 'Report Issue',
    CREATING_REPORT_ISSUE: 'Creating Report ...',
    SELECT_PROFILE: 'Select Profile',
    PROFILE: 'Profile',
    TRIPS: 'Trips',
    CHANGE_PROFILE: 'Change Profile',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    RETRY_IN_SOMETIME: 'Please, retry after some time',
    FETCHING_PROFILE: 'Fetching ...',
    UNABLE_TO_LOAD: 'We are unable to load this section!',
    BOOKING_SENT_FOR_APPROVAL: 'Your Booking has been sent for approval!',
    BOOKING_DONE: 'Your Booking has been done successfully!',
    OUT_OF_POLICY: 'Out of policy',
    IN_POLICY: 'In policy',
    VIEW_MORE: 'View more',
    DETAILS: 'Details',
    CREATE_SHELL_PNR: 'Create Shell PNR',
    PAYMENT_METHOD: 'Payment Method',
    RESET: 'Reset',
    COVID_RESTRICTIONS_TITLE: 'Important travel update',
    COVID_RESTRICTIONS_CONTENT:
      'Please ensure you are aware of any COVID-19 travel restrictions at your origin and destination. <restrictions>See restrictions.</restrictions>',
    COMPANY_LEGAL_NAME: 'Spotnana Technology Inc',
    COMPANY_LEGAL_COPYRIGHT: 'Copyright ©',
    TERMS_OF_USE: 'Terms of Use',
    PRIVACY_POLICY: 'Privacy policy',
    UNSAVED_CHANGES_TEXT: 'There are unsaved changes!',
    SAVE_UNSAVED_CHANGES: 'Save changes',
    CANCEL: 'Cancel',
    PREVIOUS_TOTAL: 'Previous total',
    UPDATED_TOTAL: 'Updated total',
    PRICE_UPDATED: 'Price has been updated',
    NO_RESULTS_FOUND: 'No results found',
    NO_RESULTS_FOUND_DESCRIPTION:
      "We couldn't find any results matching your criteria but don't worry! We have thousands of other offers. Try searching again with different criteria.",
    COPY_LOCATION: 'Copy location',
    TEXT_COPIED_TO_THE_CLIPBOARD: 'Text copied to clipboard!',
    CONFIRMATION_NUMBER_COPIED_TO_THE_CLIPBOARD: 'Confirmation number copied to clipboard!',
    AIRLINE_REFERENCE_COPIED_TO_THE_CLIPBOARD: 'Airline reference id copied to clipboard!',
    HOTEL_REFERENCE_COPIED_TO_THE_CLIPBOARD: 'Hotel reference id copied to clipboard!',
    SEARCH: 'Search',
    DELETE: 'Delete',
    DELETED: 'Deleted',
    DELETING: 'Deleting...',
    ADDRESS_LINE1: 'Address line 1',
    ADDRESS_LINE2: 'Address line 2',
    COUNTRY: 'Country',
    CITY: 'City',
    STATE: 'State, province, region',
    POSTALCODE: 'Postal/zipcode',
    EMAIL: 'Email',
    PHONE: 'Phone number',
    PHONE_COUNTRY_CODE: 'Phone country code',
    PHONE_EXTENSION: 'Phone extension',
    MOBILE: 'Mobile number',
    MOBILE_COUNTRY_CODE: 'Country code',
    MOBILE_PHONE_NUMBER: 'Mobile phone number',
    CONFIRM_BOOKING: 'Confirm your booking',
    CONTINUE: 'Continue',
    SELECT_REASON: 'Select reason',
    ABOUT: 'About',
    ADD_TRAVELER: 'Add traveler',
    ADD_TRAVELERS: 'Add travelers',
    TRAVELER: 'Traveler',
    ADD_ME: 'Add me',
    SEARCHING_PROFILES: 'Searching Profiles',
    DATE_PICKER_AND_DATE_INPUT_PLACEHOLDER: 'Select...',
    SELECT: 'Select',
    DOWNLOAD: 'Download',
    DOWNLOAD_TOOLTIP:
      'It may take up to a minute or two to download large reports, which are truncated to {{noOfRows}} rows. Please sort by any column to get relevant data in the results.',
    ADD: 'Add',
    EDIT: 'Edit',
    SAVE: 'Save',
    SAVING: 'Saving...',
    YES: 'Yes',
    NO: 'No',
    LIMO: 'Limo',
    TRAVELER_INFORMATION: 'Traveler information',
    SWIPE_RIGHT_TO_BOOK: 'Swipe right to book',
    SEE_MORE: 'See more',
    SAFETY: 'Safety',
    TRAVELERS: 'Travelers',
    MISCELLANEOUS: 'Miscellaneous',
    PHOTOS: 'Photos',
    DAYS: 'days',
    DAY: 'day',
    YEARS: 'years',
    NOT_SET: 'Not Set',
    NO_LIMIT: 'No Limit',
    STAR: 'Star',
    STARS: 'Stars',
    CONFIRM: 'Confirm',
    TEMPORARILY_LOGGED_IN: 'You have temporarily logged in as',
    WHEN_YOU_ARE_DONE: 'When you are done',
    SWITCH_BACK: 'switch back',
    TO_YOUR_ACCOUNT: 'to your account',
    LOGGED_IN_AS: 'Logged in as ',
    INTERNAL_SUB_MENU: 'Internal',
    DEBUG_TOOL_LINK: 'Debug Link',
    DEBUG_TOOL_LINK_COPY: 'copy',
    DEBUG_TOOL_LINK_COPIED: 'copied',
    RETRY_BTN_TEXT: 'Retry',
    DELETE_PHONE_NUMBER_ERROR_TITLE: 'Deletion a phone number failed',
    DELETE_PASSPORT_ERROR_TITLE: 'Deletion a passport failed',
    DELETE_LOYALTY_PROGRAM_ERROR_TITLE: 'Deletion of a loyalty program failed',
    SAVE_PHONE_NUMBER_ERROR_TITLE: 'Adding a phone number is failed',
    SAVE_PASSPORT_ERROR_TITLE: 'Saving passport failed',
    SAVE_PROFILE_ERROR_TITLE: 'Cannot save profile',
    SAVE_LOYALTY_ERROR_TITLE: 'Adding or updating loyalty is failed',
    LOADING_COMPANIES: 'Loading companies',
    NO_COMPANIES_FOUND: 'No companies found',
    PLEASE_TRY_AGAIN: 'Please try again',
    NO_COMPANIES_MATCHING_MSG: 'There are no companies matching your search',
    CHOOSE_CARD: 'Choose a card',
    SORT: 'Sort',
    DATE: 'Date',
    FILTER: 'Filter',
    CLEAR: 'Clear',
    APPLY: 'Apply',
    SELECT_ALL: 'Select All',
    GO_NATIVE_WITH_SPOTNANA: 'Go native with the Spotnana app',
    ALL_INVENTORY_CUSTOMER_SUPPORT: 'All the Inventory | 24/7 Customer Support',
    START_BOOKING_WITH_BEST_TRAVEL: 'Start booking with the best app in travel',
    TAKE_TO_APP: 'Take me to the app',
    ACTIVE: 'Active',
    REQUIRED_FIELDS: 'Required fields',
    CLICK_TO_SELECT: 'Click to select',
    UNAVAILABLE: 'Unavailable',
    CHECKOUT: 'Checkout',
    CLICK_TO_ADD_EDIT: 'Click to add or edit',
    CLICK_TO_ADD: 'Click to add',
    CASE_CODE: 'Case code',
    TRIP_NAME: 'Trip name',
    CASE_CODES: 'case codes',
    CASE_CODES_NOT_FOUND: 'No matching results were found',
    TYPE_TO_SEARCH: 'Type to search',
    TOTAL_ERROR: 'Ensure case-code percentages total 100%.',
    MISSING_PERCENTAGE_ERROR: 'Selected case-codes need a percent assigned.',
    TOTAL: 'Total',
    CLEAR_ALL: 'Clear all',
    CASE_CODES_TOOLTIP_MESSAGE:
      'It is mandatory to select case-code(s) from the list provided. If not sure what to select, contact local HR.',
    HERE_TO_HELP: "We're here to help!",
    CUSTOMER_CONSULTANTS_AVAILABLE_24_7: 'Our customer experience consultants are available 24/7',
    TALK_TO_CONSULTANT: 'Talk to a consultant',
    SUBMIT_FEEDBACK: 'Submit feedback',
    MANDATORY_FIELD: 'This is a mandatory field',
    SHELL_PNR_CONTENT_NOT_AVAILABLE: 'Content',
    SHELL_PNR_MULTI_PAX_BOOKING: 'Multi-pax booking',
    SHELL_PNR_HOLD_BOOKING: 'Hold a booking',
    SHELL_PNR_LEISURE: 'Leisure booking',
    SHELL_PNR_FUNCTIONALITY_NOT_AVAILABLE: 'Functionality not available',
    SHELL_PNR_ISSUE_WITH_OBT: 'Issue with OBT',
    SHELL_PNR_OTHER: 'Other',
    THIS_CARD_IS_NOT_SUPPORTED: 'This card is not supported',
    THE_CARD_IS_NOT_SUPPORTED_BY_THE_HOTEL: 'The card is not supported by the Hotel',
    MAXIMUM_SUPPORTED_FILE_SIZES: 'The maximum supported file sizes is 5 MB. Please try again.',
    COULD_NOT_LOAD_THE_IMAGE: 'Could not load the image. Please try again.',
    NO_TRAVELER_PROFILES_FOUND: 'No traveler profiles found',
    SEARCH_BY_NAME_OR_EMAIL: 'Search by name or email',
    COPIED: 'Copied',
    COPY: 'Copy',
    EXPIRY: 'Expiry',
    CARD_NUMBER: 'Card number',
    ALL: 'All',
    DISCOUNT: 'discount',
    CONTACT_SUPPORT: 'Contact support',
    EDIT_OR_ADD: 'Edit or add a flight to continue',
    AGENT: 'Agent',
    SHOW_OUT_OF_POLICY_OFFERS: 'Show out of policy',
    APPROVAL_NEEDED: "{{travelerName}}'s booking needs your approval",
    TRIP_APPROVED: "{{travelerName}}'s trip was approved!",
    TRIP_DENIED: "{{travelerName}}'s trip was denied!",
    APPROVER_APPROVED: "{{approverName}} has approved {{travelerName}}'s trip",
    APPROVER_DENIED: "{{approverName}} has denied {{travelerName}}'s trip",
    TRIP_THAT_IS: 'trip that is',
    BOOKING_WILL_BE_VOIDED: 'This booking will be voided on {{voidDate}}',
    RETURN_TO_SPOTNANA: 'Return to Spotnana',
    NEEDS_TO_BE_APPROVED: 'and needs to be approved by {{approverName}}',
    THAT_IS: 'that is',
    MADE_BOOKING_IN: "{{travelerName}}'s made a booking in",
    APPROVE: 'Approve',
    DENY: 'Deny',
    TRIP_VOIDED: "{{travelerName}}'s request got voided",
    REQUEST_VOIDED: "{{travelerName}}'s approval request to",
    VOIDED_BECAUSE_NO_RESPONSE: 'was voided as there was no response from {{approverName}}',
    TRIP_VOIDED_ON: 'This booking was voided on {{voidDate}}',
    TRIP_PROCESSED: "{{travelerName}}'s request has already been processed",
    REQUEST_PROCESSED: "{{travelerName}}'s approval request to",
    PROCESSED_ALREADY: 'was processed already by {{approverName}}',
    ALL_FARES_CURRENCY_INFO: 'All fares displayed are in {{currencyName}}(s).',
    ALL_FARES_CURRENCY_INFO_AVERAGE_PER_TRAVELLER:
      'All fares displayed are in {{currencyName}}(s), average per traveler.',
    PERSONAL_BOOKING_DISCLAIMER: 'This is a personal trip booking',
    RAILS: 'Rails',
    LOADING: 'Loading',
    ADDRESS_LINE_1: 'Address Line 1',
    ADDRESS_LINE_2: 'Address Line 2',
    ZIP_CODE: 'Postal/Zip Code',
    STATE_PROVINCE_REGION: 'State, Province, Region',
    SPECIAL_PRICE: 'Special price',
    YOU_SAVE_AMOUNT_ON_BOOKING: 'You save {{amount}} on this booking',
    VIA_ORGANIZATION_SPECIAL_PRICE: 'via {{organizationName}} special price',
    BREX_POINTS_REFUND_DISCLAIMER: 'Refund will be issued as points, the original form of payment for this booking.',
  },
  AUTH: {
    IS_A_PERSONAL_BOOKING: 'This is a personal booking',
    WANT_TO_BOOK_PERSONAL_BOOKING: 'Want to book a personal (leisure) trip?',
    ADD_YOUR_PEROSNAL_EMAIL: 'Please add your personal email',
    ADD_NOW: 'Add now',
    ADD_PERSONAL_EMAIL: 'Add Personal email',
    ADD_PERSONAL_EMAIL_SUBTEXT:
      'Please add your personal email address. You can always go back and edit it in your profile.',
    SUBMIT: 'Submit',
    LOG_IN: 'Log in',
    WELCOME_BACK_TO_SPOTNANA: 'Welcome back to Spotnana',
    KEEPING_YOU_SAFE_AND_SECURE: 'Keeping you safe and secure',
    WHAT_IS_YOUR_CORPORATE_EMAIL_ADDRESS: 'What is your corporate email address?',
    EMAIL: 'Email',
    FORGOT_PASSWORD: 'Forgot password?',
    FORGOT_YOUR_PASSWORD: 'Forgot your password?',
    RESET_PASSWORD: 'Reset password',
    CHECK_YOUR_EMAIL_FOR_INSTRUCTIONS: 'Check your email for instructions',
    RESET: 'Reset',
    NEXT_STEP: 'Next step',
    ORGANIZATION_NOT_FOUND: 'Organization not found',
    ACCESS_DENIED: 'Access denied by your organization',
    CONTACT_YOUR_TRAVEL_ADMIN: 'Please contact your travel administrator',
    EMAIL_US: 'Email us',
    CONTINUE: 'Continue',
    SELECT_YOUR_LOCATION: 'Select your location',
    SELECT_YOUR_DIVISION: 'Select your division',
    DIVISION: 'Division',
    CHOOSE_THE_COUNTRY_OF_YOUR_PRIMARY_OFFICE_LOCATION: 'Choose the country of your primary office location',
    CHOOSE_THE_ENTITY_YOU_WORK_FOR_FROM_THE_LIST_BELOW: 'Choose the entity you work for from the list below',
    TO_TRY_SPOTNANA: 'to try Spotnana',
    YOUR_ACCOUNT_HAS_NOT_BEEN_ACTIVATED: 'Your account has not been activated',
    CONTACT_AN_ADMINISTRATOR_TO_GET_STARTED: 'Contact an administrator to get started',
    THERE_WAS_AN_ERROR: 'There was an error',
    PLEASE_CONTACT: 'Please contact',
    SUPPORT: 'Support',
    YOUR_ACCOUNT_WAS_NOT_FOUND: 'Your account was not found',
    PLEASE_LOG_IN_WITH_YOUR_PROFESSIONAL_EMAIL: 'Please log in with your professional email',
    PLEASE_TRY_LOGGING_IN_AGAIN: 'Please try logging in again',
    PASSWORD_SHOULD_HAVE: 'Password should have',
    NEW_TO_SPOTNANA: 'New to Spotnana?',
    CREATE_YOUR_ACCOUNT: 'Create your account',
    ALREADY_USING_SPOTNANA: 'Already using Spotnana?',
    SIGN_IN_TO_YOUR_ACCOUNT: 'Sign in to your account',
    SIGN_IN: 'Sign in',
    SIGN_IN_EXTENDED: 'Sign in to Spotnana account and book your next trip in no time!',
    REGISTER: 'Register',
    CREATE_YOUR_ACCOUNT_EXTENDED: 'Create a Spotnana account and book your next trip in no time!',
    CREATE_YOUR_PASSWORD_INCLUDING: 'Create your password including:',
    ENTER_VERIFICATION_CODE_CHECK_EMAIL: 'Enter Verification Code. Check your email for instructions.',
    PLEASE_ENTER_VALID_EMAIL_ADDRESS: 'Please enter a valid email address',
    PASSWORDS_MATCH: 'Passwords match',
    PLEASE_CLICK: 'Please click',
    HERE: 'here',
    RESEND_EMAIL: 'Resend email',
    RESEND: 'Resend',
    CHANGE_PASSWORD: 'Change Password',
    DIDNT_GET_THE_CODE: 'Didn’t get the code?',
    DIDNT_RECEIVE_THE_EMAIL_PLEASE_CLICK: 'Didn’t receive the email? Please click',
    CONGRATULATIONS: 'Congratulations!',
    GOOD_TO_GO_REDIRECTED: "We're good to go! You'll be redirected to your account in few seconds.",
    FETCHING_PROFILE_DETAILS: 'Fetching profile details...',
    SIGNING_IN: 'Signing in...',
    ARENT_REDIRECTED_FEW_SECONDS: ", if you aren't redirected in a few seconds",
    BACK_TO_LOGIN: 'Back to login',
    VOID_MESSAGE: "This booking requires approval. If approval isn't received on time this booking will be voided.",
    CANNOT_BE_REFUNDED_MESSAGE:
      'This booking requires approval but cannot be refunded or exchanged. If approval is not given it will result in a loss of funds.',
  },
  AGENT: {
    SEARCH: 'Search',
    LOADING: 'Loading...',
    NO_RESULTS_FOUND: 'No results found',
    GO_TO_TRIPS: 'Go to trips',
    IN_TRIPS: 'In trips',
    SOURCE: 'Source',
    IN_COMPANY: 'In company',
    COPY_LINK: 'Copy link',
    SHARE: 'Share link',
    COPIED_SUCCESSFULLY: 'Link copied',
    SELECT_TRAVELER: 'Select a traveler',
    SELECT_TRAVELER_TO_CONTINUE: 'Select a traveler to continue',
    SELECT_TRIP_PURPOSE: 'Select trip purpose',
    CHANGE_TRAVELER: 'Change traveler',
    BOOKING_LINK_SHARED: 'Someone has shared a booking link with you',
    REASON: 'Reason',
    PNR_TYPE: 'PNR Type',
    APPROVED_NAME: 'Approved name',
    REASON_TYPE_ERROR: 'Reason type is not selected',
    PNR_TYPE_ERROR: 'PNR Type is not selected',
    ADD_MORE_DETAILS: 'Add more details',
    TOTAL_TRAVELERS: 'Total travelers',
    PASSENGER_TYPE: 'Passenger type',
    AGENT_DESKTOP: 'Agent Desktop',
    AGENT_DESKTOP_SUBTITLE: 'A new era of capabilities',
    TYPE: 'Type',
    PRIORITY: 'Priority',
    COPY: 'COPY',
    SORT: 'Sort',
    TASK: 'Task',
    GROUP: 'Group',
    TRIP_INFO: 'Trip Info',
    TRANSACTION_DATE: 'Transaction date',
    TRAVEL_START: 'Travel start',
    TRANSACTION_DATE_SORT: 'Transaction date sort',
    TRAVEL_START_SORT: 'Travel start sort',
    TRAVELER_INFO: 'Traveler info',
    ORGANIZATION: 'Organization',
    ARRANGER: 'Arranger',
    ARRANGER_INFO: 'Arranger Info',
    REFERENCE_ID: 'Reference ID',
    ASSIGNEE: 'Assignee',
    STATUS: 'Status',
    TO_DO: 'To do',
    PCC: 'PCC',
    RESET: 'Reset',
    ACTIVE_FILTER: 'Active Filter',
    COMPLETED: 'Completed',
    TOTAL_QUEUE: 'Total on queue',
    PNR_TOTAL_QUEUE: 'PNR (Total on queue)',
    URGENT_PRIORITY: 'Urgent',
    ASSIGNED_TO_ME: 'Assigned to me',
    HIGH_PRIORITY: 'High priority',
    MEDIUM_PRIORITY: 'Medium priority',
    LOW_PRIORITY: 'Low priority',
    TYPE_COMMENT: 'Type a comment',
    QUEUE_NUMBER: 'Q: {{queueNumber}}',
    MOST_RECENT: 'Most recent',
    LEAST_RECENT: 'Least recent',
    NA: 'NA',
  },
  PROFILE: {
    EMAIL_ADDRESSES: 'Email address',
    SEARCH_BY_NAME: 'Search By Name',
    SEARCH_BY_EMAIL: 'Search By Email',
    SELECT_TRAVELER: 'Select traveler',
    ADD: 'Add',
    CHANGE_TRAVELER: 'Change traveler',
    COMPLETE_PROFILE_INFORMATION: 'Complete Profile information',
    EDIT: 'Edit',
    DELETE: 'Delete',
    DELETING: 'Deleting...',
    SAVING: 'Saving...',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    SAVED: 'Saved',
    UPDATE: 'Update',
    UPDATING: 'Updating...',
    SET_DEFAULT: 'Set as default',
    REQUIRED_FIELDS: '* Required Fields',
    TRAVELER: 'Traveler',
    PROFILE: 'Profile',
    PERSONAL: 'Personal',
    WORK: 'Work',
    TRAVEL_PREFERENCES: 'Preferences',
    DONE: 'Done',
    LOYALTY: 'Loyalty',
    PAYMENT: 'Payment',
    BASIC_HEADER: 'Traveler Name',
    TITLE: 'Title',
    FIRST: 'First',
    MIDDLE: 'Middle',
    LAST: 'Last',
    SUFFIX: 'Suffix',
    BIO_TITLE: 'Traveler Information',
    GENDER: 'Gender',
    MALE: 'Male',
    FEMALE: 'Female',
    UNSPECIFIED: 'Unspecified',
    UNDISCLOSED: 'Undisclosed',
    UNKNOWN_TITLE: '-',
    MR_TITLE: 'Mr.',
    MRS_TITLE: 'Mrs.',
    MISS_TITLE: 'Miss',
    MASTER_TITLE: 'Master',
    MS_TITLE: 'Ms.',
    MX_TITLE: 'Mx.',
    PROFESSOR_TITLE: 'Prof.',
    CAPTAIN_TITLE: 'Cpt.',
    DR_TITLE: 'Dr.',
    REVEREND_TITLE: 'Rev.',
    HONOURABLE_TITLE: 'Hon.',
    SIR_TITLE: 'Sir',
    LADY_TITLE: 'Lady',
    AMBASSADOR_TITLE: 'Amb.',
    LORD_TITLE: 'Lord',
    BRIGADIER_TITLE: 'Brig.',
    SENATOR_TITLE: 'Sen.',
    DAME_TITLE: 'Dame',
    JUSTICE_TITLE: 'J',
    SR_SUFFIX: 'SR',
    JR_SUFFIX: 'JR',
    ATTY_SUFFIX: 'Atty',
    II_SUFFIX: 'II',
    III_SUFFIX: 'III',
    IV_SUFFIX: 'IV',
    MD_SUFFIX: 'M.D.',
    PHD_SUFFIX: 'Ph.D.',
    DO_SUFFIX: 'D.O.',
    DOB: 'Date of Birth',
    CONTACT_INFO_TITLE: 'Contact details',
    PHONE_NUMBER_MODAL_TITLE: 'mobile number',
    MOBILE: 'Mobile number',
    PHONE: 'Phone number',
    PHONE_COUNTRY_CODE: 'Country code',
    PERSONAL_EMAIL: 'Personal Email',
    WORK_EMAIL: 'Work Email',
    ADDRESS_TITLE_MODAL: 'address',
    ADDRESS_TITLE: 'Address',
    ADDRESS_NAME: 'Location name',
    ADDRESS_LINE1: 'Address line 1',
    ADDRESS_LINE2: 'Address line 2',
    ARRANGER_SETTINGS_TITLE: 'Arranger Settings',
    DEFAULT_ADDRESS: 'Default Address',
    COUNTRY: 'Country',
    CITY: 'City',
    STATE: 'State, Province, Region',
    POSTALCODE: 'Postal/Zipcode',
    NO_PROFILE: 'No profile found',
    TRAVEL_ID_TITLE: 'Travel Documents',
    PASSPORT: 'Passport',
    PASSPORT_ID: 'Passport No.',
    PASSPORT_BIRTH_DATE: 'Passport Birth Date',
    PASSPORT_ISSUE_DATE: 'Passport Issue Date',
    ISSUE_DATE_NOT_AVAILABLE: 'Not available',
    PASSPORT_NATIONALITY_COUNTRY: 'Nationality',
    PASSPORT_ISSUE_COUNTRY: 'Issuing Country',
    PASSPORT_EXPIRY_DATE: 'Passport Expiry Date',
    KNOWN_TRAVELER_NUM: 'Known Traveler Number',
    REDRESS_NUM: 'Redress Number',
    EMPTY_PERSONAL_INFORMATION: '* Required',
    EMERGENCY_CONTACT_MODAL_TITLE: 'emergency contact',
    EMERGENCY_CONTACT_TITLE: 'Emergency contact',
    EMERGENCY_CONTACT_PHONE: 'Mobile',
    EMERGENCY_CONTACT_EMAIL: 'Email',
    EMERGENCY_CONTACT_DESIGNATION: 'Designation',
    PAYMENT_METHODS_TITLE: 'Credit Cards',
    CARD_INFO_TITLE: 'Card Details',
    BILLING_ADDRESS_TITLE: 'Assigned billing address',
    BILLING_INFORMATION: 'Billing Information',
    CARD_TITLE: 'credit card',
    CARD_NAME: 'Cardholder name',
    CARD_LABEL: 'Card label',
    CARD_COMPANY_NAME: 'Card Company',
    EXPIRY_DATE: 'Expiry date',
    CARD_CVV: 'CVV',
    APPLICABLE_TO: 'Applicable to',
    AIR: 'Air',
    FLIGHTS: 'Flight',
    HOTELS: 'Hotel',
    CARS: 'Car',
    RAIL: 'Rail',
    RAILS: 'Rails',
    NO_SAVED_CARDS: 'Please add a Credit card',
    UNUSED_CREDITS_TITLE: 'Unused Credits',
    AIRLINE: 'Airline',
    EXPIRE: 'Expire',
    NO_EXPIRY_DATE: 'No expiry date',
    CREDITS: 'Credits',
    PNR: 'PNR',
    NO_UNUSED_CREDITS: 'There are no unused credits',
    FREQUENT_FLYER: 'Air Frequent Flyer Programs',
    HOTEL_PROGRAMS: 'Hotel Loyalty Programs',
    CAR_PROGRAMS: 'Car Loyalty Programs',
    LOYALTY_ID: 'Program number',
    FREQUENT_FLYER_TITLE: 'frequent flyer',
    LOYALTY_CARD_TITLE: 'loyalty program',
    LOYALTY_PROGRAM_AVAILABLE: 'Please select',
    LOYALTY_PROGRAM_NOT_AVAILABLE: 'Not available',
    LOYALTY_PROGRAM: 'Loyalty programs',
    EMPTY_LOYALTY: 'Please add a loyalty program',
    ADD_CUSTOM_LOYALTY: 'Add a custom loyalty program',
    NEW_BOOKING: 'New Booking',
    ALL_BOOKINGS: 'All Bookings',
    NO_BOOKINGS: 'No booking yet. Please start a new booking.',
    PNR_NO: 'PNR No.',
    STATUS: 'Status',
    NOT_AVAILABLE: 'Not Available',
    CREATED_ON: 'Created on',
    EMPTY_PNR: 'This is an empty PNR',
    PERSONAL_INFO_TITLE: 'Personal Info',
    LEGAL_NAME: 'Name on Legal ID',
    LOYALTY_INFO_TITLE: 'Loyalty Info',
    ADD_LOYALTY: 'Add Loyalty',
    PAYMENT_DETAILS_TITLE: 'Payment Details',
    USING_CREDIT_CARD: 'Using Credit Card ending with',
    OFFICE: 'Office',
    ORGANIZATION: 'Organization',
    POSITION: 'Designation',
    WORK_CONTACTS: 'Work contacts',
    WORK_PHONE: 'Work phone',
    NO_WORK_NUMBERS: 'No work phone number available!',
    WORK_ADDRESS: 'Work addresses',
    FLIGHT_PREFERENCES: 'Flight preferences',
    DEFAULT_DEPARTURE: 'Default Departure',
    PREFERED_NUMBER_STOPS: 'Preferred number of stops',
    PREFERED_ALLIANCE: 'Preferred alliance',
    PREFERED_AIRLINES: 'Preferred airlines',
    SEARCH_AIRLINE: 'Search for an airline',
    NO_AIRLINES: 'No airlines available for this search query!',
    CABIN_SEAT: 'Cabin & Seat',
    UP_TO: 'Up to',
    OVER: 'Over',
    FIRST_CLASS: 'First class',
    BUSINESS: 'Business',
    PREMIUM_ECONOMY: 'Premium Economy',
    ECONOMY_PLUS: 'Economy Plus',
    ECONOMY: 'Economy',
    AISLE: 'Aisle',
    WINDOW: 'Window',
    PREF_BULKHEAD_SEATS: 'Prefer bulkhead seats',
    SEAT_AMENITIES: 'Seat amenities',
    MEALS: 'Meals',
    PREFERRED_FOOD: 'Preferred Food',
    PREFERRED_FOOD_LABEL: 'Preferred Types',
    SPECIAL_REQUEST: 'Special requests',
    SPECIAL_REQUEST_LABEL: 'Tell us what you need',
    FARE_ATTRIBUTES: 'Fare Attributes',
    BOOKING_ALERT_PREFERENCES: 'Booking Alerts Preferences',
    ALERT_PREFERENCES_NOTE: 'If you have a travel arranger, they will get all booking alerts by default.',
    ALERT_CONFIRMATION_EMAILS: 'Confirmation Emails',
    CUSTOM_EMAILS: 'Custom Emails',
    ADD_EMAIL: 'Add Email',
    ALERT_FLIGHT_NOTIFICATIONS: 'Flight Notifications',
    DELETE_CONFIRMATION_HEADER: 'Are you sure you want to delete?',
    UNMASK_CONFIRMATION_HEADER: 'Unmask Credit Card',
    UNMASK_CONFIRMATION_LABEL: 'Are you sure you want to unmask this information?',
    REASON_FOR_REQUESTING: 'Reason for unmasking *',
    UNMASKCARD: 'Unmask',
    INFO: 'Info',
    UNMASK: 'Yes, Unmask',
    UNMASKING: 'Unmasking...',
    UNMASK_INFO_LABEL: 'If so, you understand you are uncovering credit card security.',
    DELETE_CONFIRMATION_LABEL: 'This data cannot be recovered',
    ADD_PROFILE_PHOTO: 'Add profile photo',
    CHANGE_PROFILE_PHOTO: 'Change profile photo',
    UPLOAD_PROFILE_PHOTO: 'Upload profile photo',
    UPLOAD_NEW_PHOTO: 'Upload new photo',
    SAVE_PHOTO: 'Save photo',
    REMOVE_PHOTO: 'Remove photo',
    PROFILE_PICTURE_MODAL_MESSAGE: 'Adjust your photo by dragging to reposition or changing the zoom level.',
    TRAVELER_DESCRIPTION: 'View and book travel for themself only.',
    ARRANGER_DESCRIPTION: 'View, book, and manage travel for others.',
    COMPANY_ADMIN_DESCRIPTION: 'Full admin access to everything.',
    SPOTNANA_AGENT__DESCRIPTION: 'Full admin access to everything for all companies.',
    TRAVELER_LABEL: 'Traveler',
    ARRANGER_LABEL: 'Arranger',
    COMPANY_ADMIN_LABEL: 'Company Admin',
    SPOTNANA_AGENT_LABEL: 'Spotnana Agent',
    FIRST_NAME: 'First name',
    MIDDLE_NAME: 'Middle name',
    LAST_NAME: 'Last name',
    MOBILE_PHONE_NUMBER: ' Mobile phone number',
    ADD_LOYALTY_PROGRAM: 'Add your loyalty program',
    CHOOSE_LOYALTY_PROGRAM: 'Choose loyalty program',
    TYPE_LOYALTY_PROGRAM: 'Type loyalty program',
    TYPE_PROGRAM_NUMBER: 'Type program number',
    PROGRAM_NUMBER: 'Program number',
    APPLY: 'Apply',
    COUNTRY_CODE: 'Country code*',
    PHONE_NUMBER: 'Phone number*',
    MOBILE_PHONE_NUMBERS: 'Mobile Phone numbers',
    ADD_PHONE_NUMBER: 'Add phone number',
    DELETE_PHONE_NUMBER: 'Delete phone number',
    DELETE_PHONE_NUMBER_CONFIRMATION: 'Are you sure you want to delete this phone number?',
    DELETE_PASSPORT: 'Delete passport',
    DELETE_PASSPORT_CONFIRMATION: 'Are you sure you want to delete this passport?',
    LOYALTY_PROGRAMS: 'Loyalty Programs',
    DELETE_LOYALTY_PROGRAM: 'Delete loyalty program',
    DELETE_LOYALTY_PROGRAM_CONFIRMATION: 'Are you sure you want to delete this loyalty issue?',
    SAVE_PHONE_NUMBER: 'Save phone number',
    SELECT_DOT: 'Select...',
    ADD_PASSPORT: 'Add Passport',
    YOU_HAVE_ZERO_PASSPORTS_ADDED: 'You have 0 passports added',
    YOU_HAVE_ZERO_LOYALTY_PROGRAMS_ADDED: 'You have 0 loyalty programs added',
    AIR_LOYALTY_PROGRAMS_TAB: 'Air',
    HOTEL_LOYALTY_PROGRAMS_TAB: 'Hotel',
    CAR_LOYALTY_PROGRAMS_TAB: 'Car',
    PASSPORT_ISSUING_COUNTRY: 'Passport issuing country',
    NATIONALITY_ISSUING_COUNTRY: 'Nationality issuing country',
    PASSPORT_NUMBER: 'Passport number',
    ISSUE_DATE: 'Issue date',
    EXPIRATION_DATE: 'Expiration date',
    SELECT_DATE: 'Select the date',
    PERSONAL_INFO_ID_TIP: 'Your name must match the government-issued ID that will be used on your trip.',
    SELECT_LOYALTY: 'Select loyalty',
    PURCHASE_A_FLIGHT: 'Purchase a flight',
    PURCHASE_BAGS_AIR_EXTRAS: 'Purchase bags/air extras',
    FLIGHT_EXCHANGE: 'Flight Exchange',
    HOTEL_GUARANTEE: 'Hotel Guarantee',
    OTHER: 'Other',
    SUPPLIER_REQUEST: 'Supplier Request',
    MODIFICATION: 'Modification',
    ISSUE_WITH_CONFERMA: 'Issue with Conferma',
    ISSUE_WITH_OBT: 'Issue with OBT',
    DOES_NOT_QUALIFY_FOR_LOYALTY: 'Does not qualify for loyalty points',
    NAME: 'Name',
    EMAIL: 'Email',
    CONFIRMATION_EMAILS: 'Confirmation emails',
    FLIGHT_NOTIFICATIONS: 'Flight notifications',
    ARRANGER_SETTINGS_TABLE_TITLE: 'My travellers',
    ARRANGER_SETTINGS_TABLE_MESSAGE: 'Search name or email address to add',
    SELECT_ALL_LEGAL_ENTITIES: 'Select all legal entities',
    CREDIT_CARD_LEGAL_ENTITY_HELP:
      'If this credit card is only going to be available to certain legal entities, select them here.',
    EDIT_KNOWN_TRAVELER_NUMBER: 'Edit known traveler number',
    ADD_KNOWN_TRAVELER_NUMBER: 'Add known traveler number',
    EDIT_REDRESS_NUMBER: 'Edit redress number',
    ADD_REDRESS_NUMBER: 'Add redress number',
    TSA_NUMBER: 'TSA Number',
    REGISTER_A_NEW_TRAVELER: 'Register a New Traveler',
  },
  FLIGHTS: {
    DELAYED_INVOICE_PAYMENT_MESSAGE: "This flight will get charged via your employer's saved payment method.",
    CLEANING_AND_SAFETY_PRACTICES: 'Cleaning and safety practices',
    SHOW_LESS: 'Show less',
    AMENITIES: 'Amenities',
    BASIC: 'Basic',
    ECONOMY: 'Economy',
    PREMIUM_ECONOMY: 'Premium Economy',
    ECONOMY_PLUS: 'Econ Plus',
    BUSINESS: 'Business',
    FIRST: 'First',
    FLIGHT_HIGHEST_CABIN_NONE: 'None',
    AIR_SEARCH_FORM_TRIP_TYPE_ONE_WAY: 'One-way',
    AIR_SEARCH_FORM_TRIP_TYPE_ROUND_WAY: 'Round trip',
    AIR_SEARCH_FORM_TRIP_TYPE_MULTI_CITY: 'Multi-city',
    ROUNDTRIP: 'Round trip',
    ONEWAY: 'One way',
    MULTICITY: 'Multi-city',
    SEARCH_FLIGHTS: 'Search Flights',
    WHERE_FROM: 'Where from?',
    WHERE_TO: 'Where to?',
    OUT_OF_POLICY: 'Out of Policy',
    FROM: 'From',
    TO: 'To',
    DEPARTURE: 'Departure',
    ARRIVAL: 'Arrival',
    RETURN: 'Return',
    ADD_FLIGHT: 'Add a flight',
    RELEVANCE: 'Relevance',
    PRICE: 'Price',
    PRICE_BASE: 'Price (Base)',
    PRICE_STANDARD: 'Price (Standard)',
    PRICE_ENHANCED: 'Price (Enhanced)',
    PRICE_PREMIUM: 'Price (Premium)',
    PRICE_LUXURY: 'Price (Luxury)',
    PRICE_ULTRA_LUXURY: 'Price (Ultra Lux)',
    PRICE_BASIC: 'Price (Basic)',
    PRICE_ECONOMY_PLUS: 'Price (Economy Plus)',
    PRICE_ECONOMY: 'Price (Economy)',
    PRICE_BUSINESS: 'Price (Business)',
    PRICE_FIRST: 'Price (First)',
    DEPARTURE_TIME: 'Departure Time',
    ARRIVAL_TIME: 'Arrival Time',
    CO2_EMISSION: 'CO2 emissions',
    NON_STOP: 'Non-Stop',
    ONE_STOP_OR_LESS: '1 Stop or Less',
    TWO_STOPS_OR_LESS: '2 Stops or Less',
    NO_PREFERENCE: 'No Preference',
    ALL_OPTIONS: 'All Options',
    SUMMARY: 'Summary',
    CABIN: 'Cabin',
    ALLIANCE: 'Alliance',
    ALLIANCES: 'Alliances',
    AIRLINES: 'Airlines',
    STOPS: 'Stops',
    SHOW_ITINERARY_VIEW: 'Show Itinerary View',
    DETAILS: 'Details',
    SELECT: 'Select',
    DURATION: 'Duration',
    LAYOVER: 'Layover',
    SORT_BY: 'Sort By',
    BOOK_FLIGHT: 'Book Flight',
    BOOKING_FLIGHT: 'Booking Flight',
    BOOKING: 'Booking Flight',
    REVALIDATING_FLIGHT_PRICE: 'Confirming Price',
    REVALIDATING_PRICE: 'Confirming Price',
    FLIGHT_SUMMARY: 'Flight Summary',
    MEAL_PREFERENCE: 'Meal Preference',
    TRAVELER_INFO: 'Traveler Info',
    CONFIRMATION: 'Confirmation',
    LOADING_MESSAGE: 'Loading airports...',
    CONFIRM_AND_PAY: 'Confirm and pay',
    TRAVEL_SUMMARY: 'Travel Summary',
    PAYMENT: 'Payment',
    PAYMENT_METHOD: 'Payment method',
    PASSENGER_IMPORTANT_INFO:
      'The name you enter below must exactly match the name on the government-issued ID that you will use for your trip',
    FILTER_INFO: 'Filter(s) apply per leg',
    LLF_TICKET_PRICE: 'Lowest reasonable ticket price',
    YOUR_TICKET_PRICE: 'Your ticket price',
    SELECT_TICKET_REASON: 'Please select a reason for booking this ticket.',
    TIMING_OR_SCHEDULING: 'Timing / Scheduling',
    AIRLINE_PREFERENCE: 'Airline Preference',
    AIRPORT_PREFERENCE: 'Airport Preference',
    MILEAGE_OR_PROGRAM_UPGRADE: 'Mileage / Program Upgrade',
    OTHER: 'Other Traveler Preference',
    BASE: 'Base',
    STANDARD: 'Standard',
    ENHANCED: 'Enhanced',
    PREMIUM: 'Premium',
    LUXURY: 'Luxury',
    ULTRA_LUXURY: 'Ultra Lux',
    CORPORATE_RATE: 'Corporate Rate',
    MIXED_CABIN: 'Mixed Cabin',
    VIEW_ALL_PHOTOS: 'View all photos',
    SHOW_MORE: 'Show more',
    TOTAL_DURATION: 'Total duration',
    TRAVEL_TIME: 'Travel time',
    OVERNIGHT: 'Overnight',
    OVERNIGHT_LAYOVER: 'Overnight layover',
    POLICY_RULES: 'Policy rules',
    THIS_BOOKING: 'This booking',
    REFUNDABILITY: 'Refundability',
    NO_CHANGEABLE_FILTER: 'No preference',
    REFUNDABLE_WITH_PENALTY: 'Refundable (fees may apply)',
    REFUNDABLE_WITHOUT_PENALTY: 'Refundable (no fees)',
    COVID_WARNING: 'COVID-19 Restrictions',
    IMPORTANT_UPDATE: 'Important travel update',
    SEATS: 'Seats',
    IMPORTANT_UPDATE_CONTENT:
      'Please ensure you are aware of any COVID-19 travel restrictions at your origin and destination.',
    SEE_RESTRICTIONS: 'See restrictions',
    SELECT_SEAT: 'Select Seat',
    SELECTED_SEAT: 'Selected Seat',
    ADDITIONAL_INFORMATION: 'Additional information',
    LEG: 'Leg',
    BAGGAGE: 'Baggage',
    ADD_BAGGAGE: 'Add Baggage',
    DELETE_BAGGAGE: 'Delete baggage',
    DELETE_LEG: 'Delete leg',
    CARRY_ON_BAGGAGE: 'Carry on baggage',
    CHECKED_BAGGAGE: 'Checked baggage',
    NO_DATA_AVAILABLE: 'No data available',
    TIMES: 'Times',
    DEPARTS: 'Departs',
    ARRIVES: 'Arrives',
    FARES: 'Fares',
    EARLIEST_DEPARTURE: 'Earliest Departure',
    EARLIEST_ARRIVAL: 'Earliest Arrival',
    LATEST_DEPARTURE: 'Latest Departure',
    LATEST_ARRIVAL: 'Latest Arrival',
    REFUND_TO_ORIGINAL_CARD:
      'The refund will be paid to the original payment source or as airline credits depending on the fare rules of the tickets being exchanged. Please contact support for breakdown of the refund.',
    LOYALTY_PROGRAM: 'Loyalty Program',
    AWARD_POINTS_INFO: 'We share program details with the airline, though we can’t guarantee point awards.',
    LOYALTY_APPLICABILITY_INFO:
      'Once loyalty program information is added, it will be applied to all flights by the same airline in this trip.',
    EMISSION_INFO_PART1: 'Estimated',
    EMISSION_INFO_PART2: 'output per passenger based on selected seating class.',
    EXTRA_FEES_INFO: 'This includes a service fee of {{paymentFees}} charged by the supplier',
    EMISSION_UNIT: '{{emissionValue}} kg',
    EMISSIONS: 'Emissions',
    NOT_AVAILABLE: 'Not available',
    UNITED_PASSPLUS_RATE: 'United PassPlus Rate',
    CURRENT_FLIGHT: 'Current Flight',
    FLIGHT_LEVEL_UATP_INFO:
      'Because you selected United PassPlus flight, this flight will be charged to your United PassPlus Credit.',
    UNITED_PASSPLUS_FLIGHT: 'United PassPlus - Flight',
    UNITED_PASSPLUS_FEES_AND_TAXES: 'United PassPlus - Fees and taxes',
    FEES_AND_TAXES: 'Fees and taxes',
    ELIGIBLE_REFUND: 'Eligible refund',
    FLIGHT_CREDITS: 'Flight Credits',
    SEATS_SELECTION: 'Seats selection',
    TYPE_OF_PAYMENT: 'Type of payment',
    FLIGHTS: 'Flights',
    NEW_TICKET_COST: 'New ticket cost',
    ORIGINAL_TICKET_COST: 'Original ticket cost',
    REFUND_CREDIT: 'Potential Refund / Credit / Loss',
    REFUND_CREDIT_INFO_MESSAGE:
      'This may result in a loss of funds as a refund or airline credit will only be issued in select cases depending on the ticket fare rules. For more details, please',
    TOTAL: 'Total',
    UPDATE_SEARCH: 'Refresh Search',
    PERFORM_NEW_SEARCH: 'Start New Search',
    FARE_EXPIRATION_SUBTEXT:
      'Unfortunately the fare you wished to select is no longer available - this can sometimes happen as we do not hold fares throughout the booking process.',
    FARE_EXPIRED: 'Fare Expired!',
    FARE_RULES_RESTRICTIONS_AMENITIES: 'Fare rules, restrictions and amenities',
    SELECTED_CARD: 'Selected card',
    EXCHANGING_FLIGHT: 'Exchanging flight',
    TEST_BOOKING: 'Test booking',
    CHANGE_FEES: 'Change fees',
    MIXED_CABIN_INFO_HEADING: 'This is a mixed cabin option.',
    MIXED_CABIN_INFO_MESSAGE: 'Each leg has a different cabin type as indicated below.',
    RATE: 'Rate',
    ADULTS: 'Adults',
    CHILDREN: 'Children',
    INFANTS_ON_SEAT: 'Infants on seat',
    INFANTS_ON_LAP: 'Infants on lap',
    YOUNGER_THAN_TWO: 'Younger than 2',
    FLIGHTS_MULTI_PAX_CHILDREN_SELECT_AGE:
      'Ages 2 to 17, Select the age this child will be on the date of your final flight',
    YOU_SAVED: 'You saved {{savingsInPercents}}% on this booking',
    TOTAL_AMOUNT: 'Total Amount',
    ADULT: 'Adult',
    CHILD: 'Child',
    INFANT: 'Infant',
    INFANTS: 'Infants',
    INFANT_ON_LAP: 'Infant on lap',
    YOUTH: 'Youth',
    SENIOR: 'Senior',
    CABIN_CLASS_DETAIL_BASIC_TITLE: 'Basic',
    CABIN_CLASS_DETAIL_ECONOMY_TITLE: 'Economy',
    CABIN_CLASS_DETAIL_ECONOMY_PLUS_TITLE: 'Econ Plus',
    CABIN_CLASS_DETAIL_PREMIUM_TITLE: 'Premium',
    CABIN_CLASS_DETAIL_BUSINESS_TITLE: 'Business',
    CABIN_CLASS_DETAIL_FIRST_TITLE: 'First',

    CABIN_CLASS_DETAIL_BASIC_CONTENT: 'Basic Economy fares are often the cheapest but are the most restrictive.',
    CABIN_CLASS_DETAIL_ECONOMY_CONTENT:
      'Economy fares typically include carry-on bags and seat selection. Economy Plus fares that often provide extra legroom and other perks are also included.',
    CABIN_CLASS_DETAIL_ECONOMY_PLUS_CONTENT: 'Economy Plus fares typically include extra legroom or free beverages.',
    CABIN_CLASS_DETAIL_PREMIUM_CONTENT:
      'Premium Economy typically includes more legroom, wider seats, and extra recline.',
    CABIN_CLASS_DETAIL_BUSINESS_CONTENT:
      'Business fares include both U.S. Domestic First-Class and Business Class fares. Typically these fares provide better seats, premium meals, and priority boarding.',
    CABIN_CLASS_DETAIL_FIRST_CONTENT: 'First-Class fares typically include full lie-flat beds and five-star service.',
    CABIN_CLASS_DETAILS_CTA: 'What are these six classes?',
    CABIN_CLASS_DETAILS_TITLE: 'Compare Cabin Classes',
    NON_REFUNDABLE: 'Non-refundable',
    REFUNDABLE: 'Refundable',
    CHANGES_NOT_ALLOWED: 'Changes not allowed',
    FREE_CHANGE: 'Free change',
    CHANGE_FOR_FEE: 'Change for fee',
    NON_CANCELLABLE_BOOKING: 'This is a non-cancelable booking',
    ADULT_AGE_ERROR: 'Traveler must be 18 or older.',
    INFANT_AGE_ERROR: 'Traveler must be under 24 months for the entire trip to qualify for an infant fare.',
    YOUNGER_CHILD_MIN_AGE_ERROR: 'Traveler must be 2 or older.',
    YOUNGER_CHILD_MAX_AGE_ERROR: 'Traveler must be under the age of 12 for the entire trip to travel as a child.',
    OLDER_CHILD_MIN_AGE_ERROR: 'Traveler must be 12 or older.',
    OLDER_CHILD_MAX_AGE_ERROR: 'Traveler must be under 18 for the entire trip to qualify for this fare.',
    NEXT: 'Next',
    SAVE: 'Save',
    EACH_FLIGHT_IS_SEPARATE_TICKET:
      'Each flight will be booked as separate tickets, which may result in cheaper options.',
    EACH_TICKET_CHARGED_SEPARATELY: 'Each ticket will be charged separately to the card.',
    CANCELLATION_FEE_OF_INDIVIDUAL_TICKET:
      'Cancellation fee (if any) of each individual ticket will apply on booking cancellation.',
    THINGS_YOU_SHOULD_KNOW: 'Things you should know',
    SEPARATE_TICKETS: 'Separate tickets',
    OUT_OF_POLICY_ONE_MORE: 'Out of policy, 1 more',
    BACK_TO_SEAT_SELECTION: 'Back to seat selection',
    CHECKOUT: 'Checkout',
    CHANGED_NEW_SEAT: 'Changed new seat',
    FREE: 'Free',
    CONFIRMING_SEAT: 'Confirming seat',
    NONE: 'None',
    SAVING: 'Saving...',
    AIRPORT_CHANGE: 'Airport change',
    RELATIVE_INFORMATION: 'Relative Information',
    SELECT_RELATIVE: 'Select Relative',
  },
  CARS: {
    SUMMARY: 'Summary',
    SUPPLIER: 'Supplier',
    CAR_RENTAL_COMPANIES: 'Car rental companies',
    CAR_CLASS: 'Car class',
    TYPE: 'Type',
    CAPACITY: 'Capacity',
    RATING: 'Rating',
    RELEVANCE: 'Relevance',
    PRICE: 'Price',
    DISTANCE: 'Distance',
    OTHER: 'Other',
    ECONOMY: 'Economy',
    COMPACT: 'Compact',
    MID_SIZE: 'Mid Size',
    STANDARD: 'Standard',
    FULL_SIZE: 'Full Size',
    PREMIUM: 'Premium',
    LUXURY: 'Luxury',
    CONVERTIBLE: 'Convertible',
    MINIVAN: 'Mini Van',
    MINI: 'Mini',
    SUV: 'Suv',
    VAN: 'Van',
    PICKUP: 'Pickup',
    SPORTS: 'Sports',
    SPECIAL: 'Special',
    RECREATIONAL_VEHICLE: 'Recreational Vehicle',
    PASSENGERS_2_5: '2-5 Passengers',
    PASSENGERS_6: '5+ Passengers',
    DROP_OFF: 'Drop Off',
    PICK_UP: 'Pick Up',
    SAME_AS_PICK_UP: 'Same As Pick-up',
    LOCATION_OR_AIRPORT: 'Location Or Airport',
    DATE: 'Date',
    TIME: 'Time',
    SEARCH_CARS: 'Search Cars',
    BOOK: 'Book',
    SORT_BY: 'Sort By',
    MORE_SORTING_OPTIONS: 'More Sorting Options',
    MORE_INFO: 'More Info',
    APPROX_COST: 'Approx. Cost',
    CAR_SUMMARY: 'Car Summary',
    TRAVELER_INFO: 'Traveler Info',
    CONFIRMATION: 'Confirmation',
    BOOK_CAR: 'Reserve',
    BOOKING_CAR: 'Reserving',
    RENTAL_COMPANY: 'Rental Company',
    CAR_CATEGORY: 'Car Category',
    SELECT: 'Select',
    ALL_AGENCIES: 'All agencies',
    ALL_TYPES: 'All types',
    TOTAL_COST: 'Total Cost',
    TOTAL_TAX: 'Total Tax',
    TOTAL_BASE_RATE: 'Total Base Rate',
    TOTAL: 'Total',
    TAXES_FEES: 'Taxes and fees',
    DAILY_RATE: 'Daily rate',
    INCLUDED_IN_PRICE: 'included in price',
    MUST_PRESENT_CARD: 'Must present credit card on arrival',
    PRICE_BREAKDOWN: 'Price breakdown',
    COMPANY_PREFERRED: 'Company preferred',
    COMPANY_RECOMMENDED: 'Company recommended',
    PRICE_PER_DAY: '/ day',
    AUTO_TRANSMISSION: 'Auto',
    AUTOMATIC_TRANSMISSION: 'Automatic',
    MANUAL_TRANSMISSION: 'Manual',
    TRANSMISSION: 'Transmission',
    FROM: 'From',
    NON_AIRPORT_LOCATION: 'Off airport',
    IN_TERMINAL: 'Counter and car in terminal',
    OFF_AIRPORT_RENTAL_SHUTTLE: 'Shuttle to counter and car',
    IN_TERMINAL_RENTAL_SHUTTLE: 'Shuttle to counter and car',
    ON_AIRPORT_RENTAL_SHUTTLE: 'Shuttle to counter and car',
    ON_AIRPORT_AIRPORT_SHUTTLE: 'Shuttle to counter and car',
    CALL_FOR_SHUTTLE: 'Shuttle to counter and car',
    TWO_SHUTTLES_AIRPORT_AND_RENTAL: 'Shuttle to counter and car',
    OPEN_IN_GOOGLE_MAPS: 'Open in Google maps',
    AWAY: 'Away',
  },
  HOTELS: {
    SEARCH_LABEL: 'Location, City, Airport, Hotel, Office',
    LOADING_LOCATIONS: 'Loading locations…',
    FROM: 'From',
    TO: 'To',
    SEARCH_HOTELS: 'Search Hotels',
    SUMMARY: 'Summary',
    RATING: 'Rating',
    BRANDS: 'Brands',
    AMENITIES: 'Amenities',
    RATES: 'Rates',
    LOCATION: 'Location',
    NEAR_LOCATION: 'Near Location',
    CHECK_IN: 'Check-in',
    CHECK_IN_DATE: 'Check-in date',
    CHECK_OUT: 'Check-out',
    CHECK_OUT_DATE: 'Check-out date',
    STAR_HOTEL: 'star hotel',
    NIGHT: 'Night',
    HOTEL_DETAILS: 'Hotel details',
    BOOKING_DETAILS: 'Booking details',
    AVERAGE_NIGHTLY_RATE: 'average nightly rate',
    ROOM_DETAILS: 'Details',
    RELEVANCE: 'Relevance',
    PRICE: 'Price',
    PRICE_LOWEST: 'Price (Lowest)',
    PRICE_HIGHEST: 'Price (Highest)',
    DISTANCE: 'Distance',
    CLOSEST_DISTANCE: 'Closest distance',
    HIGHEST_RATING: 'Highest rating',
    SORT_BY: 'Sort By',
    MORE_SORTING_OPTIONS: 'More Sorting Options',
    HOTEL_INFORMATION: 'Hotel Information',
    WEBSITE: 'Website',
    AVAILABLE_ROOMS: 'Available Rooms',
    MORE: 'More',
    LESS: 'Less',
    FOR: 'For',
    DAYS: 'days',
    SELECT: 'Select',
    HOTEL_SUMMARY: 'Hotel Summary',
    TELEPHONE: 'Tel',
    VIEW_ALL: 'View All',
    VIEW_LESS: 'View Less',
    TRAVELER_INFO: 'Traveler Info',
    CONFIRMATION: 'Confirmation',
    REVALIDATING_HOTEL_PRICE: 'Checking prices with the hotel',
    REVALIDATING_PRICE: 'Checking prices with the hotel',
    BOOKING: 'Booking Hotel',
    BOOKING_HOTEL: 'Booking Hotel',
    BOOK_HOTEL: 'Book Hotel',
    BOOKING_SUCCESS: 'Your booking was successful',
    PNR_NUMBER: 'Your PNR Number:',
    GO_HOMEPAGE: 'Go to Homepage',
    BACK_TO_RESULTS: 'Back to results',
    STARTING_FROM: 'starting from',
    FILTER_BY: 'Filter by',
    EARN_LOYALTY_POINTS: 'Earn loyalty points',
    FREE_CANCELLATION: 'Free cancellation',
    SHOW_CONDITIONAL_RATES: 'Show conditional rates',
    NON_REFUNDABLE: 'Non-refundable',
    BREAKFAST_INCLUDED: 'Breakfast included',
    BREAKFAST_NOT_INCLUDED: 'Breakfast not included',
    ELIGIBLE_FOR_LOYALTY_POINTS: 'Loyalty points',
    NOT_ELIGIBLE_FOR_LOYALTY_POINTS: 'Not eligible for loyalty program status points',
    PRICE_DETAILS: 'Price details',
    FILTER_BY_HOTEL_NAME: 'Filter by hotel name',
    SOLD_OUT: 'Show sold out',
    BASE_AMOUNT: 'Base amount',
    SUMMARY_OF_CHARGES: 'Summary of charges',
    TAX: 'Tax',
    FEES: 'Fees',
    TOTAL: 'Total',
    FILTER: 'Filter',
    APPLIED: 'applied',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    SHOW_ROOMS: 'Show rooms',
    NO_ROOMS_AVAILABLE: 'No rooms available',
    NO_ROOMS_AVAILABLE_WITH_FILTER: 'There are no rooms available matching your filters',
    NO_FILTERS_APPLIED: 'No filters applied',
    NO_AVAILABILITY: 'No availability',
    ADD_ROOM: 'Add room',
    DONE: 'Done',
    OPEN_WITH: 'Open with',
    CONFIRM_AND_PAY: 'Confirm and pay',
    UNTIL: 'until',
    ON_CANCELLATION: 'on cancellation',
    NOT_ELIGIBLE_REFUND: 'Not eligible for refund',
    BACK_TO_DETAILS: 'Back to hotel details',
    SWITCH_TO_LIST_VIEW: 'Switch to list view',
    SWITCH_TO_MAP_VIEW: 'Switch to map view',
    SEARCHING_HOTELS: 'Finding you a great hotel',
    SEARCHING_HOTELS_DESCRIPTION: 'Hundreds of places to stay coming up',
    NO_RESULTS_FOUND_DESCRIPTION: 'Try adjusting your search criteria or zooming out on the map.',
    SEARCH_THIS_AREA: 'Search this area',
    AWAY: 'away',
    NEGOTIATED_RATE: 'Negotiated rate',
    SPOTNANA_RATE: 'Spotnana rate',
    FOR_COUNT_NIGHTS: 'for {{count}} night',
    FOR_COUNT_NIGHTS_plural: 'for {{count}} nights',
    HOTEL_SEARCH_AREA: 'Less than {{value}} {{unit}}',
    MORE_FILTERS: 'More filters',
    TERMS: 'I have read and accepted the <restrictions>Expedia Group Terms and Conditions</restrictions> of Travel.',
  },
  ADMIN: {
    CC_EMAILS_TITLE: 'Email recipient list',
    CC_EMAILS_BUTTON: 'Add Email',
    CC_EMAILS_MESSAGE:
      'Please specify the email addresses that should be copied in all booking, notification and travel-status emails.',
    CC_EMAILS_ERROR_MESSAGE: 'The email is already in the list',
    CC_EMAILS_EMAIL: 'Email',
    DELETE: 'Delete',
    CHOOSE_ORGANIZATION: 'Choose organization',
    ADMIN_PAGE_HEADING: 'Settings',
    COMPANY: 'Company',
    GENERAL: 'General',
    SERVICE_FEE: 'Service fee',
    ROLES: 'Roles',
    LEGAL_ENTITIES: 'Legal entities',
    OFFICES: 'Offices',
    PAYMENT_METHODS: 'Payment methods',
    AUTHENTICATION: 'Authentication',
    LOGIN_AS_USER: 'Log in as user',
    USERS: 'Users',
    GENERAL_SETTINGS_HEADING: 'General',
    COMPANY_NAME: 'Company name',
    COMPANY_NAME_PLACEHOLDER: 'Type your company name',
    EMAIL_DOMAIN: 'Email domain',
    EMAIL_DOMAIN_TOOLTIP: 'Add all email domains that your organization uses. For example: abc.com, xyz.org',
    EMAIL_DOMAIN_PLACEHOLDER: 'example.com',
    BILLING_CURRENCY: 'Billing currency',
    BILLING_CURRENCY_TOOLTIP: 'Select the primary currency for invoicing',
    BILLING_CURRENCY_PLACEHOLDER: 'Select a currency',
    EMERGENCY_CONTACT_TITLE: 'Emergency contact',
    ADD_CONTACT: 'contact',
    COMPANY_LOGO_TITLE: 'Company logo',
    ADD_COMPANY_LOGO: 'Add company logo',
    CHANGE_COMPANY_LOGO: 'Change company logo',
    CHANGE_COMPANY_LOGO_MESSAGE: 'Adjust your company logo by dragging to reposition or changing the zoom level.',
    EMPTY_L1_REMARKS_HEADER: 'Nothing to see here yet.',
    LEGAL_ENTITIES_HEADER: 'Legal entities',
    CREATE_LEGAL_ENTITIES_BUTTON: 'Create legal entity',
    EMPTY_LEGAL_ENTITIES_HEADER: 'Nothing to see here yet.',
    EMPTY_USER_LIST_HEADER: 'No users found!',
    EMPTY_ORGANIZATION_LABEL: 'To start lets fill up the general information about the company',
    EMPTY_LEGAL_ENTITIES_LABEL: "Now, let's add the first legal entity to the company you created",
    LEGAL_ENTITY_NAME: 'Legal entity name',
    DOING_BUSINESS_AS: 'Doing business as',
    TAX_NUMBER: 'Tax number',
    ADD_LEGAL_ENTITY_HEADER: 'Add new legal entity',
    ADD_LEGAL_ENTITY_BUTTON: 'Add new legal entity',
    EDIT_LEGAL_ENTITY_HEADER: 'Edit legal entity',
    EDIT_LEGAL_ENTITY_BUTTON: 'Save',
    OFFICES_HEADER: 'Offices',
    CREATE_OFFICE_BUTTON: 'Create office',
    EMPTY_LEGAL_ENTITY_OFFICE_HEADER: "Let's start with the legal entities",
    EMPTY_LEGAL_ENTITY_OFFICE_LABEL: 'To create the office, create the legal entity first',
    EMPTY_OFFICE_HEADER: 'Nothing to see here yet.',
    EMPTY_OFFICE_LABEL: "Now, let's add the first office to the legal entity you created",
    EMPTY_L1_LABEL: 'Please fill in L1 remarks or contact your admin to complete company details',
    LEGAL_ENTITY_FOR_OFFICE: 'Legal entity',
    OFFICE_NAME: 'Office name',
    ADD_OFFICE_HEADER: 'Add new office',
    ADD_OFFICE_BUTTON: 'Add new office',
    EDIT_OFFICE_HEADER: 'Edit office',
    EDIT_OFFICE_BUTTON: 'Save',
    EMPLOYEES: 'Employees',
    OFFICE_HAS_EMPLOYEES: 'The office has employees associated',
    DELETE_OFFICE_HAS_EMPLOYEES_HEADER: 'This office is associated with users!',
    DELETE_OFFICE_HAS_EMPLOYEES_LABEL: 'Please reassign the users to new offices to continue',
    DELETE_CONFIRMATION_HEADER: 'Are you sure you want to delete?',
    DELETE_CONFIRMATION_LABEL: 'This data cannot be recovered',
    LEGAL_ENTITY_HAS_OFFICES_AND_EMPLOYEES_HEADER: 'This legal entity is associated with offices and users!',
    LEGAL_ENTITY_HAS_OFFICES_AND_EMPLOYEES_SUBHEADER: 'Please reassign the users to new offices to continue.',
    CANCEL: 'Cancel',
    BACK: 'Back',
    NEW_COMPANY: 'new company',
    TMC: 'TMC',
    USER_UPLOAD: 'User upload',
    CHOOSE_CSV_FILE: 'Choose CSV file',
    USER_UPLOAD_CONTENT:
      'The file needs to include the full list of employees that should be in the company. Employees that are not included in the file will lose access.',
    EMPTY_USER_UPLOAD_HEADER: 'Nothing to see here yet.',
    AUTHENTICATION_PAGE_HEADER: 'Authentication',
    AUTHENTICATION_METHOD: 'Authentication method',
    AUTHENTICATION_METHOD_HELPER_TEXT: 'Choose how your employees log into Spotnana',
    PASSWORD: 'Password',
    GOOGLE_SSO: 'Google SSO',
    AZURE_SSO: 'Microsoft Azure SSO',
    USER_AUTO_PROVISIONED_ALLOWED: 'User auto-provisioning allowed',
    USER_AUTO_PROVISIONED_ALLOWED_HELPER_TEXT:
      'Employees can register for their own Spotnana account. Only allow this if email addresses are not reassigned within your organization',
    APPLICATION_ID: 'Application ID',
    APPLICATION_ID_HELPER_TEXT: 'Provided by Spotnana',
    EMPTY_AUTHENTICATION_HEADER: 'Nothing to see here yet.',
    SELECT_USER: 'Select user',
    ADD_NEW_USER: 'Add new user',
    DELETE_USER: 'Delete user',
    CONFIGURE_USER_HEADER: 'Configure users',
    CONFIGURE_USER_LABEL: 'Add a new user or select an existing user to modify',
    TRAVELER_INFORMATION_TITLE: 'Traveler information',
    TRAVELER_TYPE_TITLE: 'Traveler Type',
    TRAVELER_TYPE: 'Type',
    TRAVELER_TYPE_EMPLOYEE: 'Employee',
    TRAVELER_TYPE_GUEST: 'Guest',
    TRAVELER_TYPE_LEISURE: 'Leisure',
    NAME_SECTION_TITLE: 'Name',
    CONTACT_SECTION_TITLE: 'Contact Details',
    EMPLOYMENT_SECTION_TITLE: 'Employment Details',
    MANAGER_SECTION_TITLE: 'Manager Details',
    PREFERRED_CURRENCY_SECTION_TITLE: 'Preferred Currency',
    TITLE: 'Title',
    FIRST_NAME: 'First name',
    MIDDLE_NAME: 'Middle name',
    LAST_NAME: 'Last name',
    NAME: 'Name',
    SUFFIX: 'Suffix',
    EMAIL: 'Email',
    EMPLOYEE_ID: 'Employee ID',
    EMPLOYEE_ID_INFO:
      "Unique identifier for the employee. If your organization does not have unique IDs then use the employee's email address",
    JOB_TITLE: 'Job title',
    MANAGER: 'Manager',
    COMPANY_SETTINGS_TITLE: 'Company settings',
    LEGAL_ENTITY: 'Legal entity',
    OFFICE: 'Office',
    USER_ROLE_TITLE: 'User role',
    ROLE: 'Role',
    ROLE_TRAVELER_HEADER: 'Traveler',
    ROLE_TRAVELER_LABEL: 'Visa och boka resor endast för sig själva',
    ROLE_ARRANGER_HEADER: 'Arranger',
    ROLE_ARRANGER_LABEL: 'View, book and manage travel for others',
    ROLE_COMPANY_ADMIN_HEADER: 'Company admin',
    ROLE_COMPANY_ADMIN_LABEL: 'Full admin access to everything',
    SAVE_BUTTON: 'Save',
    ADD_BUTTON: 'Add',
    USER_CAN_MANAGE_ACCOUNTS_FOR: '{{firstName}} can manage the accounts for:',
    ARRANGER_FOR_USERS: 'Arranger for all of the following users',
    ADD_USER: 'Add user',
    REMARKS: 'L1 Remarks',
    DELETE_USER_HEADER: 'Delete "{{fullName}}"?',
    DELETE_USER_LABEL: "This will revoke {{fullName}}'s access",
    DELETE_EMPTY_USER_HEADER: 'Delete the user?',
    DELETE_EMPTY_USER_LABEL: "This will revoke user's access",

    // Policy Translations

    POLICY: 'Policy',
    TRAVELER_DESCRIPTION: 'View and book travel for themself only',
    ARRANGER_DESCRIPTION: 'View, book, and manage travel for others',
    COMPANY_ADMIN_DESCRIPTION: 'Full admin access to everything',
    SPOTNANA_AGENT__DESCRIPTION: 'Full travel agent access for all companies',
    SPOTNANA_ADMIN_DESCRIPTION: 'Full admin access to everything for all companies',
    TRAVELER_LABEL: 'Traveler',
    ARRANGER_LABEL: 'Arranger',
    GLOBAL_AGENT_LABEL: 'Universal agent',
    GLOBAL_ADMIN_LABEL: 'Universal admin',
    COMPANY_TRAVEL_ARRANGER_LABEL: 'Company Travel Arranger',
    TRAVEL_ARRANGER_LABEL: 'Travel Arranger',
    COMPANY_ADMIN_LABEL: 'Company admin',
    SPOTNANA_AGENT_LABEL: 'Universal agent',
    SPOTNANA_ADMIN_LABEL: 'Universal admin',
    EVERYONE_LABEL: 'Everyone',
    INDIVIDUALS_LABEL: 'Individuals',
    PREFERRED_VENDORS: 'Preferred vendors',
    UNITED_PASS_PLUS: 'United PassPlus',
    ADD_GENERAL_AIRLINE_PROGRAM: 'Add general airline program',
    DELETE_VENDOR_PROGRAM: 'Delete vendor Program',
    AIRLINE_PROGRAMS: 'Airline programs',
    ADD_UNITED_PASS_PLUS: 'Add United PassPlus',
    UNITED_PASS_PLUS_APPLICABILITY_CRITERIA:
      'The details to enable United Pass Plus will be within the welcome letter that United will have provided you.',
    SAVE: 'Save',
    SAVING: 'Saving...',
    SEARCH_HOTEL: 'Search Hotel',
    SEARCH_CAR_VENDOR: 'Search Car Vendor',
    LOADING: 'Loading...',
    NO_RESULTS_FOUND: 'No results found',
    ADD_HOTEL_BUTTON: 'Add hotel',
    ADD_CAR_VENDOR_BUTTON: 'Add car vendor',
    HOTEL_VENDORS: 'Hotel vendors',
    CAR_VENDORS: 'Car vendors',
    SUPPLIER: 'Supplier',
    SUPPLIERS: 'Suppliers',
    CREATE_PCC: 'Add PCC',
    PCC_LIST: 'PCC List',
    PCC: 'PCC',
    PCC_PLURAL: 'PCCs',
    SET_DEFAULT_SUBTITLE_CONFIRM: 'This will replace your current default PCC ({{currentDefaultPcc}}).',
    SET_DEFAULT_CONFIRM: 'Are you sure you want to set PCC {{pcc}} as default?',
    CREDENTIALS: 'Credentials',
    APPLICABLE_TO: 'Applicable to',
    DK_NUMBER: 'Dk number',
    TIMEZONE: 'Timezone',
    IATA: 'IATA',
    AWS_KEYS: 'Aws keys',
    QUEUE: 'Queue',
    PRIMARY_QUEUE: 'Primary Queue',
    SECONDARY_QUEUE: 'Secondary Queue',
    SELECT_CURRENCY: 'Select currency',
    DISCOUNT_CODES: 'Discount Codes',
    AIRLINES: 'Airlines',
    ADD_CODE: 'Add code',
    NO_AIRLINE_SELECTED: 'No airline selected',
    AIRLINE_CODE: 'Airline code',
    AIR_TOUR_CODES: 'Air tour codes',
    AIR_TOUR_CODE: 'Air tour code',
    AIR_CLID3_CODES: 'Air CLID3 codes',
    AIR_CLID3_CODE: 'Air CLID3 code',
    AIR_CLID4_CODES: 'CLID4 codes',
    AIR_CLID4_CODE: 'CLID4 code',
    HOTEL_RATE_CODES: 'Hotel rate codes',
    RATE_CODE: 'Rate code',
    BACK_TO_SUPPLIERS: 'Back to Suppliers',
    ADD_SUPPLIER: 'Add Supplier',
    NUMBER_OF_EXCLUDED_AIRLINES: '# of Excluded Airlines',
    NUMBER_OF_DISCOUNT_CODES: '# of discount codes',
    EMPTY_SUPPLIER_LIST_HEADER: 'Nothing to see here yet',
    NO_VENDORS_ADDED: 'No vendors added',
    SEARCH_VENDOR: 'Search for vendors to add',
    HOTEL_NAME: 'Hotel name',
    LOCATION_NAME: 'Location',
    PREFERRED_VENDOR_DUBLICATE: 'This vendor has already been added',
    TMC_ADMIN_LABEL: 'TMC admin',
    TMC_AGENT_LABEL: 'TMC agent',
    TMC_ADMIN_DESCRIPTION: 'Manages TMC configuration and user management',
    TMC_AGENT_DESCRIPTION: 'Manages bookings for customers',
    VENDOR_NAME: 'Vendor name',
    SEAT1A_CTA: 'Mark as Seat 1A',
    SEAT1A_CTA_SUBTEXT: 'Activate if you wish to provide special status to this user',
    SEAT1A_FILTER: 'Show only Seat 1A',
    DELAYED_INVOICING: 'Delayed invoicing',
    CAR_DISCOUNT_CODE: 'Car Corporate Discount code',
    CENTRAL_CARD_APPLICABLE_TEXT: 'This credit card can be used by all travelers for air transactions',
    CAR_CORPORATE_CODE: 'Corporate code',
    CANCEL_BUTTON: 'cancel',
  },
  TMC: {
    TMC_PAGE_HEADING: 'TMC Configuration',
    SETTINGS: 'Settings',
    CUSTOMIZE: 'Customize',
    GENERAL: 'General',
    REMARKS: 'TMC Remarks',
    SUPPLIERS: 'Suppliers',
    COMPANY_LIST: 'Company list',
    COMPANY_NAME: 'Company name',
    COMPANY_NAME_PLACEHOLDER: 'Type your company name',
    EMAIL_DOMAIN: 'Email domain',
    EMAIL_DOMAIN_TOOLTIP: 'Add all email domains that your organization uses. For example: abc.com, xyz.org',
    EMAIL_DOMAIN_PLACEHOLDER: 'example.com',
    TMC_DEFAULT_PCC: 'TMC Default PCC',
    BILLING_CURRENCY: 'Billing currency',
    BILLING_CURRENCY_TOOLTIP: 'Select the primary currency for invoicing',
    BILLING_CURRENCY_PLACEHOLDER: 'Select a currency',
    TMC_DEFAULT_PCC_ADD: 'PCC',
    TMC_DEFAULT_PCC_TOOLTIP: 'PCC',
    SELECT_PCC_PLACEHOLDER: 'Select PCC',
    NO_PCC_CONFIGURED: 'no PCCs configured',
    PCC_DELETE_BUTTON: 'Delete',
    DEFAULT_PCC_ERROR_EMPTY: 'You must select at least one travel type',
    DEFAULT_PCC_ERROR_INTERSECTIONS: 'Default PCC must be mutually exclusive',
    ADD_COMPANY: 'Add company',
    EMPTY_LIST_MESSAGE: 'Nothing to see here yet.',
    SEARCH: 'Search',
    SEARCH_PLACEHOLDER: 'Search for a company',
    RATE_CODES: 'TMC rate codes',
    BACKOFFICE_SETUP: 'Backoffice setup',
    LOGO: 'Logo',
    EMAIL: 'Email',
    FRESHDESK_SETTING: 'Freshdesk setting',
    SUPPORT_SETTING: 'Support setting',
    DK_NUMBER_FIELD: 'DK Number',
    FILTER_ID_FIELD: 'Filter ID',
    TEMPLATE_ID_FIELD: 'Template ID',
    PNR_REMARK: 'PNR Remark',
    PNR_REMARK_TITLE: 'remark',
  },
  REPORTS_AND_ANALYTICS: {
    DATE_TYPE: 'Date type',
    TIMEZONE: 'Timezone',
    CURRENCY: 'Currency',
    EDIT_TIMEZONE: 'Edit timezone',
    DATES_AND_TIMES_IN: 'Dates and times in {{timezone}} {{suffix}}',
    UNLESS_OTHERWISE_NOTED: 'unless otherwise noted',
    SPEND_DATA_SHOWN_IN: 'Spend data is shown in {{currency}}',
    ALL_DATA_BASED_ON: 'All data is based on {{dateType}}',
    TRANSACTION_DATES: 'transaction dates',
    DATA: 'Data',
    ANALYTICS: 'Analytics',
    TRAVEL_START_DATE: 'Travel start date',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    LAST_30_DAYS: 'Last 30 days',
    LAST_FULL_MONTH: 'Last full month',
    LAST_3_MONTHS: 'Last 3 months',
    LAST_FULL_QUARTER: 'Last full quarter',
    LAST_6_MONTHS: 'Last 6 months',
    LAST_12_MONTHS: 'Last 12 months',
    LAST_WEEK: 'Last week',
    YESTERDAY: 'Yesterday',
    TOMORROW: 'Tomorrow',
    NEXT_WEEK: 'Next week',
    NEXT_30_DAYS: 'Next 30 days',
    CUSTOM_RANGE: 'Custom range',
    TRAVEL_TYPE: 'Travel type',
    PLEASE_TRY_AFTER_SOMETIME: 'Please try after sometime.',
    NO_RESULTS: 'No results!',
    REPORTS: 'Reports',
    CHOOSE_REPORT: 'Choose report',
    SEARCH_BY: 'Search by',
    AVERAGE_POLICY_COMPLIANCE: 'Average policy compliance',
    NO_DATA: 'Nothing found',
    TRY_SEARCHING_WITH_DIFFERENT_REPORT_FILTER_VALUES: 'Try a different filter',
    TRY_AGAIN_AFTER_SOME_TIME: 'Try again after some time',
    LEGAL_ENTITIES_COULD_NOT_BE_LOADED: 'Legal entities could not be loaded',
    ALL_BOOKINGS_IN_POLICY: 'All bookings are in policy',
    APPLY_FILTERS_TO_START: 'Apply the filters to get started!',
    AVERAGE_PRICE_BY_SERVICE: 'Average price by service',
    AIR: 'Air',
    CAR: 'Car',
    HOTEL: 'Hotel',
    TOPK_TRAVELERS_NAME: 'Name',
    TOPK_TRAVELERS_TOTAL_SPEND: 'Total spend',
    TOPK_TRAVELERS_POLICY_BOOKINGS: 'policy bookings',
    TOPK_TRAVELERS_SERVICE: 'Service',
    COMPARED_TO: 'Compared to',
    // TODO(Rushil): Use LOCALISED_NUMBER instead for i18n.
    PERCENTAGE: '00.0%',
    ALL_TRAVEL: 'All travel',
    TOTAL_SPEND: 'Total spend',
    TOTAL_BOOKINGS: 'Total bookings',
    TOTAL_SPEND_OR_BOOKINGS: 'Total spend/bookings',
    UNIQUE_FLIGHTS: 'Unique flights',
    TICKET_COUNTS: 'Ticket counts',
    SPEND: 'spend',
    BOOKINGS: 'bookings',
    TOTAL_TRAVEL_SPEND: 'Total travel spend',
    AIR_SPEND: 'Air spend',
    CAR_SPEND: 'Car spend',
    HOTEL_SPEND: 'Hotel spend',
    CAR_DETAIL: 'Car detail',
    HOTEL_DETAIL: 'Hotel detail',
    FLIGHT_DETAIL: 'Flight detail',
    TRAVEL_OVERVIEW: 'Travel overview',
    AIR_TRANSACTION_DETAIL: 'Air transaction detail',
    REPORT_SUMMARY: 'Report summary',
    APPLY: 'Apply',
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    NAME: 'Name',
    OUT_OF_POLICY_BOOKINGS: 'Out of policy bookings',
    PERCENTAGE_IN_POLICY: '% in policy',
    TOPK_TRAVELERS_BY_SUB_ANALYTICS_TYPE: 'Top {{K}} travelers by {{analyticsTableSubType}}',
    POLICY_BOOKING: 'Policy bookings',
    CHECKIN_DATE: 'Check-in date',
    DEPARTURE_DATE: 'Departure date',
    PICKUP_DATE: 'Pick-up date',
    TRANSACTION_DATE: 'Transaction date',
    CHARGED_DATE: 'Charged date',
    ORGANIZATION: 'Organization',
    CARBON_FOOTPRINT: 'Carbon Footprint (Air)',
    TOTAL: 'Total CO',
    EMISSION: 'emission (Air)',
    TONS: 'tons',
    SINCE: 'since',
  },
  RAILS: {
    RAIL_SEARCH_FORM_SEARCH_TYPE_ONE_WAY: 'One way',
    RAIL_SEARCH_FORM_SEARCH_TYPE_ROUND_TRIP: 'Round trip',
    RAIL_SEARCH_FORM_SEARCH_TYPE_OPEN_RETURN: 'Open return',
    SEARCH_RAIL: 'Search Rail',
    RAIL: 'Rail',
    WHERE_FROM: 'Where from?',
    WHERE_TO: 'Where to?',
    DEPARTURE: 'Departure',
    RETURN: 'Return',
    OUTBOUND: 'Outbound',
    OPEN_RETURN: 'Open Return',
    LOADING_MESSAGE: 'Loading stations...',
    ADD_RAIL_CARD: 'Add railcard',
    SUGGESTIONS: 'Suggestions',
    NO_RAIL_CARDS_FOUND: 'No railcards found',
    NO_RAIL_CARD_IN_PROFILE: 'There are no railcards in your profile.',
    TRY_DIFFERENT_SEARCH: 'Please try a different search!',
    ASSIGN_RAILCARD: 'Assign a railcard',
    LEAVING_AT: 'Leaving at',
    ARRIVING_BY: 'Arriving by',
    RAIL_CARDS: 'Railcards',
    ADD_NEW: '+ Add New',
    STANDARD: 'Standard',
    FIRST_CLASS: '1st Class',
    ROUTE: 'Route',
    SHOW_EARLIER_OPTIONS: 'Show earlier options',
    SHOW_LATER_OPTIONS: 'Show later options',
    NO_RESULTS_FOUND: 'No Results Found',
    OUTBOUND_FROM: 'Outbound from',
    TOTAL: 'Total',
    SELECT_AND_CONTINUE: 'Select and continue',
    ANY_VALID_TRAIN: 'Any valid train',
    TRAVELCARD: 'Travelcard',
    TRAVELCARD_DESCRIPTION:
      'As you are travellng into London you are able to add a Travelcard as part of this journey. Depending on the ticket you select this will allow you to travel on buses and tubes',
    TICKET_DELIVERY: 'Ticket Delivery',
    SEAT_PREFERENCES: 'Seat Preferences',
    SEAT_RESERVATION_PREFERENCES: 'Seat Reservation Preferences',
    IMPORTANT_INFORMATION: 'Important Information',
    IMPORTANT_INFORMATION_DESCRIPTION:
      'Don’t forget to bring your {{railCard}} with you when you travel. Failure to do so will result in the full undiscounted fare being payable.',
    TRAVELCARD_COLLECTION_RULES: 'Travelcard collections rules',
    E_TICKET: 'E-Ticket',
    E_TICKET_DESCRIPTION:
      'Your e-ticket(s) will be sent to your email and will be viewable on the mobile app, if available. You will also receive an itinerary confirmation separately.',
    E_TICKET_HELPER: 'How to use e-tickets',
    KIOSK: 'Collect from any station with a ticket machine',
    KIOSK_DESCRIPTION:
      'You will need a payment card and your collection reference. Tickets will be ready for collection shortly after booking.',
    KIOSK_HELPER: 'Ticket collections rules',
    UNRECOGNIZED: 'Unrecognized option',
    UNRECOGNIZED_DESCRIPTION: 'There is something wrong',
    UNKNOWN: 'Unknown option',
    UNKNOWN_DESCRIPTION: 'Something went wrong',
    SEAT_PREF_WARNING:
      "We'll request your seating preferences with the train operator, but they are not always guaranteed.",
    POSITION: 'Position',
    DIRECTION: 'Direction',
    CARRIAGE_TYPE: 'Carriage type',
    RAIL_TICKETS: 'Rail Tickets',
    FEES_AND_TAXES: 'Fees and Taxes',
    RAIL_CARD: 'Railcard',
    TRAVELCARD_TICKET: 'Travelcard ticket',
    TERMS: 'I have read and accepted the <restrictions>National Rail Conditions</restrictions> of Travel.',
    AMTRAK_TERMS:
      'I have read and agree to the <restrictions>terms and conditions</restrictions>, including the binding arbitration agreement and rules regarding COVID travel. The privacy policy applies.',
    CONFIRM_BTN_TEXT: 'Confirm and pay',
    NEXT: 'Next',
    SEE_FARE_DETAILS: 'see fare details',
    PAYMENT_METHOD: 'Payment method',
    FARE_DETAILS: 'Fare details',
    ADD: 'Add',
    EDIT: 'Edit',
    RESET: 'Reset',
    NO_RAILCARD_SELECTED: 'No railcard selected',
    TICKET_COLLECTION_REFERENCE: 'Ticket collection reference',
    LOCATIONS: 'Locations',
    VENDING_MACHINES:
      'All of our stations have ticket vending machines from London King"s Cross right through to Edinburgh and beyond.',
    THINGS_NEEDED: 'Things you"ll need:',
    REFERENCE: 'Ticket Collection Reference given to you when the booking was made.',
    CARD: 'Credit / debit card used to make the booking.',
    STEPS: 'Follow these three simple steps:',
    INSERT_CARD: 'Insert the debit or credit card you used to purchase the tickets.',
    ENTER_REFERENCE: 'Enter the reference if you have one.',
    PRINTED_TICKETS_IN_TRAY:
      'The machine will check your details and print your tickets, they"ll appear in the tray below.',
    PRINT_TICKETS:
      'There may be quite a few tickets and reservation coupons to collect so don"t rush off until you"re sure everything has been printed and the main screen says that the transaction is complete.',
    TICKET_COLLECTION_RULES_EXCEPT:
      'You will be able to collect your ticket(s) from any other <restrictions>1500 stations</restrictions> listed.',
    TICKET_COLLECTION_RULES:
      'You will be able to collect your ticket(s) from <restrictions>1500 stations</restrictions> listed, but you must collect your tickets before you start your journey.',
  },
  CONCIERGE: {
    COMPLEX_TRIP: 'Complex Trip',
    AIRPORT_TRANSFER: 'Airport Transfer',
    OTHERS: 'Other',
    FINISH_SCREEN_BUTTON: 'Send request again',
    INVALID_INPUT_ERROR: 'Please do not add URL links or HTML tags in the request',
  },
  TRIPS: {
    SHOWING_RESULTS_FOR: 'Showing results for',
    UPCOMING: 'Upcoming',
    PAST: 'Past',
    CANCELLED: 'Canceled',
    NEW_TRIP: 'New Trip',
    VIEW_RECEIPT: 'View receipt',
    TRIPS: 'Trips',
    TRIP_ID: 'Trip ID',
    BOOK_A_TRIP: 'Book a Trip',
    UPCOMING_TRIPS: 'Upcoming',
    NO_UPCOMING_TRIPS: 'No upcoming trips',
    THERE_ARE_NO_UPCOMING_TRIPS: 'There are no upcoming trips',
    PAST_TRIPS: 'Past',
    NO_PAST_TRIPS: 'No past trips',
    NO_CANCELLED_TRIPS: 'No canceled trips',
    THERE_ARE_NO_PAST_TRIPS: 'There are no past trips',
    SOMETHING_WENT_WRONG: 'Something’s wrong. Try again in a few minutes',
    ADD_FLIGHT: 'Add Flight',
    ADD_HOTEL: 'Add Hotel',
    ADD_CAR: 'Add Car',
    ADD_RAIL: 'Add Rail',
    ADD_LIMO: 'Add Limo',
    OTHER: 'Other',
    OUTBOUND_FLIGHT: 'Outbound Flight',
    RETURN_FLIGHT: 'Return Flight',
    PENDING: 'Pending',
    REQUESTED: 'Requested',
    VOIDED: 'Voided',
    CONFIRMED: 'Confirmed',
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
    REFUNDED: 'Refunded',
    GET_STARTED_ON_YOUR_NEXT_TRIP: 'Get started on your next trip',
    READY_TO_GO: 'Ready to go?',
    NEW_BOOKING: 'New booking',
    NOTHING_TO_SEE: 'Nothing to see here yet',
    MANUALLY_ADD_BOOKINGS: 'You can manually add bookings',
    SEARCH_FLIGHT: 'Search flight',
    SEARCH_HOTEL: 'Search hotel',
    SEARCH_RAIL: 'Search rail',
    SEARCH_CAR: 'Search car',
    SEARCH_LIMO: 'Search limo',
    OUTSIDE_BOOKING: 'Outside booking',
    ENTER_DETAILS_MANUALLY: 'Enter details manually',
    CREATE_A_NEW_TRIP: 'Create a New Trip',
    SELECT_A_TRIP: 'Select a Trip',
    TRIP: 'Trip',
    ADD_TO_EXISTING_TRIP: 'Add to existing trip',
    TITLE_OF_TRIP: 'Title of Trip',
    DESCRIPTION_OF_TRIP: 'Description of Trip',
    SERVICE_FEE: 'Service fee',
    TOTAL_AMOUNT_PAYABLE: 'Total amount payable',
    TOTAL: 'Total',
    FLIGHT_DETAILS: 'Flight details',
    ONE_WAY: 'One way',
    ROUND_TRIP: 'Round trip',
    MULTI_CITY: 'Multi city',
    THIRD_PARTY_SUPPLIER_NAME: 'Third party supplier name',
    THIRD_PARTY_CONFIRMATION_NUMBER: 'Third party confirmation number',
    WHERE_FROM: 'Where from',
    WHERE_TO: 'Where to',
    DEPARTURE_DATE_AND_TIME: 'Departure date and time',
    ARRIVAL_DATE_AND_TIME: 'Arrival date and time',
    MARKETING_AIRLINES: 'Marketing airlines',
    MARKETING_AIRLINES_FLIGHT_NUMBER: 'Marketing airlines flight number',
    OPERATING_AIRLINES: 'Operating airlines',
    OPERATING_AIRLINES_FLIGHT_NUMBER: 'Operating airlines flight number',
    CONFIRMATION_NUMBER: 'Confirmation number',
    BRANDED_FARE: 'Branded fare',
    SEAT_NUMBER: 'Seat number',
    CABIN_CLASS: 'Cabin class',
    ECONOMY: 'Economy',
    FIRST_CLASS: 'First Class',
    PREMIUM_ECONOMY: 'Premium Economy',
    ECONOMY_PLUS: 'Economy Plus',
    BUSINESS: 'Business',
    ADD_SEGMENT: 'Add segment',
    ADD_DESTINATION: 'Add destination',
    TICKET_DETAILS: 'Ticket details',
    ENTER_ALPHANUMERIC: 'Enter alphanumeric',
    BASE_FARE: 'Base fare',
    TAXES: 'Taxes',
    ADD_EXTRAS: 'Add extras',
    TYPE: 'Extra',
    AMOUNT: 'Amount',
    FULL_AMOUNT: 'Full amount',
    LOWER_FARE_DECLINED: 'Lower fare declined',
    OUT_OF_POLICY: 'Out of policy',
    SELECT_REASON: 'Select Reason',
    CHARGE_TRAVELER: 'Charge Traveler',
    SELECT_CARD: 'Select card',
    TICKET_NUMBER: 'Ticket number',
    TICKET_NUMBERS_AND_COST: 'Ticket numbers and cost',
    SPLIT_COST: 'Split cost',
    COMBINE_COST: 'Combine cost',
    COST_PER_PERSON: 'Cost per person',
    TOTAL_AMOUNT: 'Total Amount',
    TRIP_TYPE: 'Trip type',
    UNKNOWN_STATUS: 'Unknown',
    REFUNDED_STATUS: 'Refunded',
    UNRECOGNIZED: 'Unrecognized',
    DELAYED: 'Delay',
    GATE_CHANGED: 'Gate changed',
    TERMINAL_CHANGED: 'Terminal changed',
    CONNECTION_RISK: 'Connection risk',
    REINSTATED: 'Reinstated',
    MULTIPLE_UPDATES: '{{count}} update',
    MULTIPLE_UPDATES_plural: '{{count}} updates',
    STARTS: 'Starts',
    STARTED: 'Started',
    BOOKED: 'Booked',
    ENDS: 'Ends',
    ENDED: 'Ended',
    FLIGHT_DELAYED: 'Flight - Delayed',
    FLIGHT_GATE_CHANGED: 'Flight - Gate changed',
    FLIGHT_CONNECTION_RISK: 'Flight - Connection Risk',
    FLIGHT_DIVERTED: 'Flight - Diverted',
    FLIGHT_CANCELLED: 'Flight - Canceled',
    FLIGHT_REINSTATED: 'Flight - Reinstated',
    FLIGHT_MULTIPLE_UPDATES: '{{count}} Flight update',
    FLIGHT_MULTIPLE_UPDATES_plural: '{{count}} Flight updates',
    PERSONAL_TRIP: 'Personal trip',
  },
  TRIP_DETAILS: {
    TOTAL: 'Total',
    TRAIN_TO: 'Train to',
    RAIL_INFO: 'Rail info',
    FLIGHT_INFO: 'Flight info',
    FARE_INFORMATION: 'Fare information',
    CONFIRM_CANCELLATION: 'Confirm cancellation',
    CANCEL_ALL_TICKETS: 'Cancel all tickets',
    REFUND_DETAILS: 'Refund details',
    PRICE_BREAKDOWN: 'Price breakdown',
    REFUND_AMOUNT: 'Refund amount',
    FLIGHTS: 'Flights',
    BAGGAGE: 'Baggage',
    ORIGINAL_FARE: 'Original fare',
    PAID_SEAT: 'Paid seat',
    UPDATE: 'Update',
    PAYMENT_DETAILS: 'Payment details',
    SHARE_VIA_EMAIL: 'Share via email',
    SHARE_THIS_TRIP: 'Share this trip',
    WHERE_TO_RECEIVE_EMAIL: 'Where would you like to receive email of your trip details?',
    SEND_EMAIL: 'Send Email',
    PAYMENT_METHOD: 'Payment method',
    GRAND_TOTAL: 'Grand total',
    FLIGHT_TO: 'Flight to',
    FLIGHTS_TO: 'Flights to',
    FLIGHT_TO_DESTINATION: 'Flight to {{destination}}',
    BACK_TO_TRIPS: 'Back to trips',
    TRIP_STARTS: 'TRIP STARTS',
    TRIP_ENDS: 'TRIP ENDS',
    CANCEL: 'Cancel',
    CHANGE: 'Change',
    CHANGE_HOTEL: 'Change hotel',
    CANCEL_HOTEL: 'Cancel hotel',
    TRIP_NOT_FOUND: 'trip details not found',
    CONFIRMATION: 'Confirmation: {{confirmationId}}',
    ITEM_CONFIRMATION_NUMBER: 'Confirmation number',
    BOOKING_ID: 'Booking ID: {{bookingId}}',
    BOOKING_ID_LABEL: 'Booking id',
    HOTEL_REFERENCE: 'Hotel Reference: {{hotelReference}}',
    HOTEL_REFERENCE_LABEL: 'Hotel Reference',
    AIRLINE_REFERENCE: 'Airline Reference: {{airlineReference}}',
    AIRLINE_REFERENCE_LABEL: 'Airline Reference',
    SPOTNANA_REFERENCE: 'Spotnana Reference: {{spotnanaReference}}',
    COLLECTION_REFERENCE: 'Collection Reference: {{ticketReference}}',
    SPOTNANA_REFERENCE_LABEL: 'Spotnana Reference',
    CHECK_IN: 'Check-In',
    CHECK_OUT: 'Check-Out',
    LOCATION: 'Location',
    HOTEL_AMENITIES: 'Hotel amenities',
    HOTEL_PHONE_NUMBER: 'Hotel phone number',
    ROOM_AMENITIES: 'Room amenities',
    ROOM_DETAILS: 'Room details',
    MORE_AMENITIES: '{{num}} more amenities',
    SHOW_MORE: 'Show more',
    SEE_MORE: 'See more',
    VIEW_MAP: 'View map',
    CANCELLATION_TERMS: 'Cancellation Terms',
    ARRIVAL: 'Arrival',
    DEPARTURE: 'Departure',
    DURATION: 'Duration',
    LAYOVER: 'Layover',
    OPERATED_BY: 'Operated by',
    OPERATED_BY_OPERATOR: 'Operated by {{operator}}',
    STOP_NUMBERS_0: 'Non Stop',
    STOP_NUMBERS_1: '1 Stop',
    STOP_NUMBERS: '{{numOfStops}} Stops',
    FLIGHT_DETAILS: 'Flight Details',
    TRAVELLER_DETAILS: 'Traveler Details',
    TRAVELERS: 'Travelers',
    FARE_RULES_AND_RESTRICTIONS: 'Fare rules and restrictions',
    TRIP_NAME_UPDATED: 'Trip Name Updated',
    ADD_ITEM: 'Add item',
    FLIGHT: 'Flight',
    TERMINAL: 'Terminal',
    GATE: 'Gate',
    ONLINE_CHECK_IN: 'Online check-in',
    CANCEL_FLIGHT: 'Cancel flight',
    PICK_UP: 'Pick-up',
    DROP_OFF: 'Drop-off',
    CANCEL_CAR: 'Cancel car',
    READ_MORE: 'Read more',
    VIEW_MORE_AMENITIES: 'View more amenities',
    BOOKING_HISTORY: 'Booking history',
    UPDATED_ON: 'updated this on',
    EXCHANGED_ON: 'exchanged this on',
    BOOKED_ON: 'booked this on',
    CANCELLED_ON: 'canceled this on',
    BOOKING_HISTORY_NAME: 'A {{tmcName}} agent',
    NUMBER_OF_DAYS: '{{count}} day',
    NUMBER_OF_DAYS_plural: '{{count}} days',
    DAYS_CAR_RENTAL: '{{count}} day car rental',
    DURATION_CAR_RENTAL: '{{duration}} car rental',
    CAR_TYPE: '{{type}} car',
    DOWNLOAD_RECEIPT: 'Download receipt',
    TSA_NUMBER: 'TSA Number',
    REDRESS_NUMBER: 'Redress Number',
    ORIGINAL_FLIGHT_COST: 'Original Flight Cost',
    SEAT: '{{count}} Seat',
    SEAT_plural: '{{count}} Seats',
    TICKET_NUMBER: 'Ticket Number',
    LOYALTY_INFORMATION: 'Loyalty Information',
    SEAT_SELECTION: 'Seat Selection',
    SEATS_SELECTION: 'Seats selection',
    BASE_FARE: 'Base fare',
    TAX_FARE: 'Tax fare',
    TOTAL_FARE: 'Total Fare',
    TOTAL_TRIP_FARE: 'Total Trip Fare',
    // Leg Statuses
    PENDING: 'Pending',
    CANCELLED: 'Canceled',
    VOIDED: 'Voided',
    CONFIRMED: 'Confirmed',
    COMPLETED: 'Completed',
    REFUNDED: 'Refunded',
    // Pnr Statuses
    UNKNOWN: 'Unknown',
    INITIATED: 'Initiated',
    // CANCELLED: 'Cancelled',
    // CONFIRMED: 'Confirmed',
    GROUP_BOOKING_ON_REQUEST: 'Group booking on request',
    WAITLISTED: 'Waitlisted',
    // PENDING: 'Pending',
    AIRLINE_UPGRADE: 'Airline upgrade',
    WAITLIST_CONFIRMED: 'Waitlist confirmed',
    BOOKING_DENIED_CONTACT_SUPPORT: 'Booking denied, contact support',
    NO_SHOW: 'No show',
    CONTACT_SUPPORT: 'Contact support',
    STATUS_CHANGED_CONTACT_SUPPORT: 'Status changed, contact support',
    SCHEDULE_CHANGE: 'Schedule change',
    SEGMENT_REQUEST: 'Segment request',
    SCHEDULE_CHANGE_WAITLISTED_BOOKING: 'Schedule change waitlisted booking',
    REQUEST_PENDING: 'Request pending',
    WAITLISTED_NOT_CONFIRMED: 'Waitlisted not confirmed',
    SCHEDULE_CHANGE_NOT_CONFIRMED: 'Schedule change not confirmed',
    SCHEDULE_CHANGE_PENDING_STATUS: 'Schedule change pending status',
    MIS_CONNECTION: 'Misconnection',
    REQUESTED: 'Requested',
    TICKETED: 'Ticketed',
    // VOIDED: 'Voided',
    CANCELLED_BY_VENDOR: 'Canceled by vendor',
    CANCELLATION_IN_PROGRESS: 'Cancellation in progress',
    UNRECOGNIZED: 'Unrecognized',
    SEAT_BELTS: '{{count}} seat belt',
    SEAT_BELTS_plural: '{{count}} seat belts',
    TOTAL_BAGS: '{{count}} total bag',
    TOTAL_BAGS_plural: '{{count}} total bags',
    SMALL_BAGS: '{{count}} small bag',
    SMALL_BAGS_plural: '{{count}} small bags',
    LARGE_BAGS: '{{count}} large bag',
    RENTAL_CONDITIONS: 'Rental conditions',
    LARGE_BAGS_plural: '{{count}} large bags',
    IMPORTANT_INFORMATION: 'Important information',
    NON_REFUNDABLE: 'Non refundable',
    NO_CHANGES_REFUND: 'No changes refund',
    UNTIL: 'Until',
    FREE_CANCELLATION: 'Free cancelation',
    LIMO_SERVICE: 'Limo service',
    DRIVER_DETAILS: 'Driver details',
    NO_OF_DAYS: '{{count}} day',
    OTHER_TRAVEL_ITEM: 'Other travel item',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    DESCRIPTION: 'Description',
    CONTACT_AGENTS: 'Please contact Spotnana Agents to make any amendments or cancellations to your rail ticket',
    CANCELLATION_AND_EXCHANGE_INFORMATION: 'Cancellation and Exchange Information',
    TRAVELER_INFORMATION: 'Traveler information',
    REFUND: 'Refund',
    YES: 'Yes',
    NO: 'No',
    REFUND_TYPE: 'Refund type',
    PARTIAL_REFUND: 'Partial refund',
    FULL_REFUND: 'Full refund',
    ORIGINAL_PRICE: 'Original price',
    CURRENCY: 'Currency',
    AMOUNT: 'Amount',
    REFUND_AMOUNT_ERROR_MSG: 'Refund amount should be less than or equal to original amount',
    FREE_CANCELLATION_MSG: 'Your reservation qualifies for free cancellation',
    CANCEL_CAR_RESERVATION: 'Cancel Car reservation',
    YOUR_CURRENT_RESERVATION: 'Your current reservation',
    BACK_TO_TRIPS_OVERVIEW: 'Back to trips overview',
    VIEW_HOTEL: 'View hotel',
    CANCEL_LIMO_RESERVATION: 'Cancel Limo reservation',
    AT: 'At',
    NON_REFUNDABLE_MSG: 'This booking is non refundable',
    CANCEL_RESERVATION: 'Cancel reservation',
    CANCEL_FLIGHT_RESERVATION: 'Cancel Flight reservation',
    CANCEL_HOTEL_RESERVATION: 'Cancel Hotel reservation',
    CANCEL_RAIL_RESERVATION: 'Cancel Rail reservation',
    CANCEL_MISC_RESERVATION: 'Cancel Other reservation',
    CANCEL_FLIGHT_SUCCESS_MSG: 'Your flights have been successfully canceled',
    CANCEL_CAR_SUCCESS_MSG: 'Your car reservation has been successfully canceled',
    CANCEL_LIMO_SUCCESS_MSG: 'Your limo reservation has been successfully canceled',
    CANCEL_HOTEL_SUCCESS_MSG: 'Your hotel reservation has been successfully canceled',
    CANCEL_RAIL_SUCCESS_MSG: 'Your rail reservation has been successfully canceled',
    CANCEL_MISC_SUCCESS_MSG: 'Your reservation has been successfully canceled',
    REFUND_MSG: 'Please allow 5-10 business days for your refund of {{amount}} to appear on your credit card statement',
    REFUND_MSG_BREX_POINTS:
      'Please allow {{duration}} for refund of {{brexPoints}} points to be credited back to your points balance.',
    TOTAL_REFUND: 'Total Refund',
    CONTACT_US: 'Contact us',
    AMOUNT_WILL_GET_CREDITED_MSG:
      ' An airline credit in the amount of {{amount}}  will be added to your account. To redeem your airline credit please',
    PLEASE: 'Please',
    CANCEL_YOUR_ITENARY_MSG: 'If you would like to cancel your itinerary',
    CONTACT_US_TO_CANCEL_INTINERARY: 'Contact us to cancel itinerary',
    FLIGHT_PLURAL: 'Flights',
    AIRLINE_CREDIT: 'Airline credit',
    PENALTY: 'Penalty',
    FEES_AND_TAXES: 'Fees and taxes',
    EXTRAS: 'Extras',
    CANCELLATION_POLICY: 'Cancellation policy',
    SEAT_PREFERENCE: 'Seat preference',
    TO: 'To',
    SHOW: 'Show',
    ITEMS: 'Items ({{count}})',
    EMPTY_TRIPS_MSG:
      'Continue adding other bookings while this completes, it might take a few minutes for this to reflect in your trips page',
    UPDATE_RESERVATION: 'Update reservation',
    UPDATE_FLIGHT_RESERVATION: 'Update flight reservation',
    RESERVATION_CHANGED_BY_AIRLINE:
      'Your airline has changed your reservation. The details below may differ from your current booking. Please contact us if you need any assistance.',
    NOT_AVAILABLE: 'Not Available',
    REINSTATED: 'Reinstated',
    ALL_TICKETS_PART_OF_SAME_BOOKING:
      'All tickets listed below are part of the same booking. Canceling this will cancel all tickets in it.',
    TO_CANCEL_INDIVIDUAL_TICKET: 'To cancel an individual ticket please ',
    CANCEL_ALL_TICKETS_WARNING:
      'This will cancel all the tickets in the booking. Cancellation fee (if any) of each individual ticket will apply.',
    BACK_TO_TRIP_DETAILS: 'Back to trip details',
    SPOTNANA_SERVICE_FEE: 'Spotnana Service Fee',
  },
  DUTY_OF_CARE: {
    TRAVELERS_REPORT: 'Travelers Report',
    LOCATION: 'Location',
    SEARCH_COUNTRIES: 'Search for countries...',
    LOADING_COUNTRIES: 'Loading countries...',
    NO_COUNTRIES: 'No countries found!',
    SEARCH_CITIES: 'Search for cities...',
    LOADING_CITIES: 'Loading cities...',
    NO_CITIES: 'No cities found!',
    SEARCH_AIRPORTS: 'Search for airports...',
    LOADING_AIRPORTS: 'Loading airports...',
    NO_AIRPORTS: 'No airports found!',
    SELECT_CONTINENTS: 'Select continents',
    NO_CONTINENTS: 'No continents found!',
    CLEAR: 'Clear',
    FLIGHT_NUMBER: 'Flight number',
    DEP_AIRPORTS: 'Departure airports',
    ARR_AIRPORTS: 'Arrival airports',
    NOTHING_TO_SEE: 'Nothing to see yet',
    BUILD_NEW_REPORT: 'You can build a new report above',
    TRANSACTION_INFO_MSG: 'Download transaction details of your past, current or future travelers',
    DATA_NOT_FOUND: "Sorry the user's data could not be loaded. Please try again later.",
    DATA_COULD_NOT_BE_FETCHED: 'Data could not be fetched. Please try again later',
    MAP: 'Map',
    TRAVELER_REPORTS: 'Traveler Reports',
    LIVE_MAP: 'Live',
    MULTIPLE_FLIGHTS: 'Multiple flights',
    SELECTED_MAP_AREA: 'Selected map area',
    SELECTED_MARKER: 'Selected location',
    MAP_TOOLTIP_CONTENT: 'Live Map shows the current location of your travelers',
    TRIP_SEGMENTS: 'trip segments',
  },
  BOOKING_IMPORTER: {
    CAR_DETAILS: 'Car details',
    CONTACT: 'Contact',
    CAR_RENTAL_COMPANY: 'Car rental company',
    MILEAGE: 'Mileage',
    CONF_NO: 'Conf. no',
    EMAIL_ADDRESS: 'Email address',
    PHONE_NUMBER: 'Phone number',
    PICK_UP: 'Pick-up',
    DROP_OFF: 'Drop-off',
    AIRPORT: 'Airport',
    ADDRESS_LINE: 'Address line',
    ZIPCODE: 'Zipcode',
    CITY: 'City',
    STATE: 'State/Province',
    DEPARTURE_DATE_AND_TIME: 'Departure date and time',
    VEHICLE_INFORMATION: 'Vehicle information',
    FUEL_POLICY: 'Fuel Policy',
    NUMBER_OF_SEATS: 'Number of seats',
    NUMBER_OF_DOORS: 'Number of doors',
    ENGINE_TYPE: 'Engine type',
    AIR_CONDITIONING: 'Air conditioning',
    TRANSMISSION: 'Transmission',
    CAR_TYPE: 'Car type',
    ELECTRIC_VEHICLE: 'Electric vehicle',
    LARGE_SUITCASE_LIMIT: 'Large suitcase limit',
    SMALL_SUITCASE_LIMIT: 'Small suitcase limit',
    PAYMENT_METHOD: 'Payment method',
    CHARGING_METHOD: 'Charging method',
    OUT_OF_POLICY: 'Out of policy',
    COST: 'Cost',
    AMOUNT: 'Amount',
    PERCENTAGE: 'Percentage',
    BASE_FARE: 'Base Fare',
    BASE_FARE_AMOUNT: 'Base fare amount',
    TAXES: 'Taxes',
    ADD_EXTRA: 'Add Extra',
    FULL_AMOUNT: 'Full amount',
    AIRPORT_CODE: 'Airport code',
    PICKUP_TYPE: 'Pick-up type',
    LIMO_DETAILS: 'Limo details',
    ADD_SEGMENT: 'Add Segment',
    YES: 'Yes',
    NO: 'No',
    UNKNOWN: 'Unknown',
    STANDARD_CAR: 'Standard Car',
    EXECUTIVE_CAR: 'Executive Car',
    BUSINESS_VAN: 'Business Van',
    FIRST_CLASS: 'First Class',
    PAY_TO_LIMO_VENDOR: 'Pay to limo vendor',
    PREPAID: 'Pre-paid',
    SELECT_METHOD: 'Select method',
    EXTRA: 'Extra',
    PICKUP_LOCATION: 'Pick-up location',
    DROPOFF_LOCATION: 'Drop-off location',
    PICKUP_DATE_TIME: 'Pick-up date and time',
    DROPOFF_DATE_TIME: 'Drop-off date and time',
    DRIVER_NAME: 'Driver name',
    LIMO_COMPANY: 'Limo company',
    PICKUP_NOTE: 'Pick-up note',
    DROPOFF_NOTE: 'Drop-off note',
    CANCEL: 'Cancel',
    RETRY: 'Retry',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    OUTSIDE_BOOKING_ADDED: 'Outside booking added!',
    VIEW_TRIP: 'View trip',
    OUTSIDE_BOOKING_SUCCESS_MSG: 'The outside booking has been added to the trip',
    IS_REQUIRED: 'is required',
    PICKUP_DATE_TIME_ERROR: 'Pick-up date and time should be before Drop-off date and time',
    DROPOFF_DATE_TIME_ERROR: 'Drop-off date and time should be after Pick-up date and time',
    UNKNOWN_CAR_TYPE: 'Unknown',
    HOTEL_DETAILS: 'Hotel details',
    BOOKING_DETAILS: 'Booking details',
    HOTEL_NAME: 'Hotel name',
    CONFIRMATION_NUMBER: 'Confirmation no.',
    CANCELLATION_NUMBER: 'Cancellation no.',
    CHECK_IN_DATE_AND_TIME: 'Check-in date and time',
    CHECK_OUT_DATE_AND_TIME: 'Check-out date and time',
    STAR_RATING: 'Star rating',
    COUNTRY: 'Country',
    SELECT_TIME: 'Select time',
    ROOM_DETAILS: 'Room details',
    ROOM: 'Room',
    BED_TYPE: 'Bed type',
    NUM_OF_BEDS: 'No. of beds',
    NUM_OF_ROOMS: 'No. of rooms',
    CANCELLATION_POLICY: 'Cancellation policy',
    COST_PER_NIGHT: 'Base rate per night',
    COST_PER_PERSON: 'Cost per person',
    ROOM_CHARGES: 'Room charges',
    NUM_OF_NIGHTS: 'No. of nights',
    TOTAL_AMOUNT: 'Total amount',
    ARRIVAL_DATE_AND_TIME: 'Arrival date and time',
    LOCATION: 'Location',
    RESET: 'Reset',
    DELETE: 'Delete',
    ADD_BOOKING: 'Add Booking',
    DELETE_BOOKING: 'Delete Booking',
    ALPHANUM_ONLY: 'Alphanumeric characters only',
    SHOULD_BE_NON_NEGATIVE: 'should be non-negative',
    EXCHANGE_RATES_UNAVAILABLE: 'Exchange rates unavailable',
    CANNOT_BE_AFTER: 'should be before',
    CANNOT_BE_BEFORE: 'should be after',
    IS_INVALID: 'is invalid',
    SELECT_CARD: 'Select card',
    ENTER_DATE_AND_TIME: 'Enter date and time',
    POLICY: 'Policy',
    OTHER_TYPE: 'Other type',
    METHOD: 'Method',
    DEADLINE: 'Deadline',
    LOADING_LOCATIONS: 'Loading locations...',
    FREE_CANCELLATION_UNTIL: 'Free cancellation until',
    NON_REFUNDABLE: 'Non-refundable',
    OTHER: 'Other',
    PAY_AT_HOTEL: 'Pay at hotel',
    DOUBLE: 'Double',
    FUTON: 'Futon',
    KING: 'King',
    MURPHY: 'Murphy',
    QUEEN: 'Queen',
    SOFA: 'Sofa',
    TATAMI_MATS: 'Tatami mats',
    TWIN: 'Twin',
    SINGLE: 'Single',
    FULL: 'Full',
    RUN_OF_THE_HOUSE: 'Run of the house',
    DORM: 'Dorm',
    WATER: 'Water',
    PULL_OUT: 'Pull out',
    UNLIMITED: 'Unlimited',
    LIMIT: 'Limit',
    KM: 'km',
    MILES: 'mile',
    UNIT: 'Unit',
    CALL_FOR_SHUTTLE: 'Call for shuttle',
    IN_TERMINAL: 'In terminal',
    IN_TERMINAL_RENTAL_SHUTTLE: 'In terminal shuttle',
    OFF_AIRPORT_RENTAL_SHUTTLE: 'Off airport shuttle',
    ON_AIRPORT_AIRPORT_SHUTTLE: 'Airport shuttle',
    TWO_SHUTTLES_AIRPORT_AND_RENTAL: 'Two shuttles airport and rental',
    UNKNOWN_COUNTER: 'Unknown counter',
    MINI: 'Mini',
    ECONOMY: 'Economy',
    COMPACT: 'Compact',
    MID_SIZE: 'Mid size',
    STANDARD: 'Standard',
    FULL_SIZE: 'Full size',
    PREMIUM: 'Premium',
    LUXURY: 'Luxury',
    CONVERTIBLE: 'Convertible',
    MINIVAN: 'Mini van',
    SUV: 'SUV',
    VAN: 'Van',
    PICKUP: 'Pickup',
    SPORTS: 'Sports',
    SPECIAL: 'Special',
    RECREATIONAL_VEHICLE: 'Recreational vehicle',
    PAY_AT_CAR_VENDOR: 'Pay at car rental vendor',
    PETROL: 'Petrol',
    DIESEL: 'Diesel',
    ELECTRIC: 'Electric',
    CNG: 'CNG',
    AC_AVAILABLE: 'Available',
    AC_NOT_AVAILABLE: 'Not Available',
    MANUAL_UNSPECIFIED_DRIVE: 'Manual',
    AUTO_UNSPECIFIED_DRIVE: 'Automatic',
    COACH: 'Coach',
    SEAT: 'Seat',
    CABIN: 'Cabin',
    SHOULD_BE_POSITIVE: 'should be positive',
    NO_CREDIT_CARD_AVAILABLE: 'Add credit card details in the user profile to enable charge traveler',
    TO: 'To',
    FROM: 'From',
    RAIL_CARRIER: 'Carrier',
    TRAIN_NUMBER: 'Train no.',
    CLASS: 'Class',
    FARE_TYPE: 'Fare type',
    FIRST: 'First',
    RAIL_DETAILS: 'Rail details',
    TICKET_INFORMATION: 'Ticket information',
    COACH_AND_SEAT: 'Coach and seat',
    ONE_WAY: 'One way',
    ROUND_TRIP: 'Round trip',
    TRIP_TYPE: 'Trip type',
    THIRD_PARTY_SUPPLIER_NAME: 'Third party supplier name',
    THIRD_PARTY_CONFIRMATION_NUMBER: 'Third party confirmation number',
    TICKET_DELIVERY_METHOD: 'Ticket delivery method',
    SELECT_DELIVERY_METHOD: 'Select delivery method',
    KIOSK: 'Kiosk',
    ELECTRONIC_TICKET: 'Electronic ticket',
    COMBINE_COST: 'Combine cost',
    SPLIT_COST: 'Split cost',
    TICKET_NUMBERS_AND_COST: 'Ticket numbers and cost',
    TICKET_COLLECTION: 'Enter ticket collection no.',
    UPLOAD_PDF: 'Upload PDF',
    RETURN: 'Return',
    CURRENCY: 'Currency',
    START_DATE_TIME_ERROR: 'Start date and time should be before End date and time',
    END_DATE_TIME_ERROR: 'End date and time should be after Start date and time',
    MISCELLANEOUS_DETAILS: 'Miscellaneous details',
    START_DATE_AND_TIME: 'Start date and time',
    END_DATE_AND_TIME: 'End date and time',
    DESCRIPTION: 'Description',
    START_TIME: 'Start time',
    END_TIME: 'End time',
    CANCELLATION_POLICY_DEADLINE_ERROR: 'Deadline should be before pick-up date and time',
    ARRIVAL_DATE_TIME_ERROR: 'Arrival date and time should be greater than Departure date and time',
    OPEN_RETURN: 'Open return',
    SHOULD_BE_AFTER: 'should be after',
    PREVIOUS: 'previous',
    THIRD_PARTY: 'Third party',
    SPOTNANA_CONFIRMATION_NUMBER: 'Spotnana confirmation number',
    AIRLINE_CONFIRMATION_NUMBER: 'Airline confirmation number',
    SHOULD_BE_LESS_THAN_TOTAL_AMOUNT: 'Should be less than total amount',
    SHOULD_BE_LESS_THAN_OR_EQUAL_TO_TOTAL_AMOUNT: 'Should be less than or equal to total amount',
    NEAREST_AIRPORT: 'Nearest airport',
    PRICE_SUMMARY: 'Price summary',
    HOTEL: 'Hotel',
    CREATE: 'Create',
    UPDATE_OR_EDIT: 'Edit / Update',
    REFUND: 'Refund',
    EXCHANGE: 'Exchange',
    CHANGE_TYPE: 'Change type',
    HOTEL_INFORMATION: 'Hotel information',
    TRANSACTION_DATE: 'Transaction date',
    REFUND_AMOUNT: 'Refund amount',
    PENALTY: 'Penalty',
    TAX_REFUND: 'Refund of taxes',
    FULL_REFUND_AMOUNT: 'Full refund amount',
    BOOKING: 'Booking',
    EDIT_OR_UPDATE: 'Edit / update',
    REFUND_BASE_FARE: 'Refund base fare',
    REFUND_TAXES_AMOUNT: 'Refund taxes amount',
    VEHICLE_TYPE: 'Vehicle type',
    SEGMENT: 'Segment',
    SAVE: 'Save',
    ADD_AIR_SEGMENT_TO_LEG: 'Add air segment to LEG {{legNumber}}',
    ADD_BAGGAGE_TO_LEG: 'Add baggage to LEG {{legNumber}}',
    ADD_SEAT_TO_AIR_LEG_SEGMENT: 'Add seat to LEG {{legNumber}}, Air segment {{airSegmentNumber}}',
    DELETE_SEAT: 'Delete seat',
    DELETE_SEGMENT: 'Delete segment',
    TICKET_DETAILS_WITH_NUMBER: 'Ticket {{ticketNumber}} details',
    TICKET_TYPE: 'Ticket type',
    TICKET_NUMBER: 'Ticket number',
    NEW_TICKET_NUMBER: 'New ticket number',
    ADD_LEG: 'Add a leg',
    ADD_NEW_FLIGHT_TICKET: 'Add new flight ticket',
    DELETE_TICKET: 'Delete ticket',
    COMMISSION: 'Commission',
    LEG_WITH_NUMBER: 'Leg {{legNumber}}',
    DELETE_LEG: 'Delete leg',
    LEG_SEGMENT_AIR: 'Leg {{legNumber}}, segment {{segmentNumber}} - air',
    LEG_SEGMENT_SEAT: 'Leg {{legNumber}}, segment {{segmentNumber}} - seat {{seatNumber}}',
    MARKETING_AIRLINES: 'Marketing airlines',
    MARKETING_AIRLINES_FLIGHT_NO: 'Marketing airlines flight no.',
    OPERATING_AIRLINES: 'Operating airlines',
    OPERATING_AIRLINES_FLIGHT_NO: 'Operating airlines flight no.',
    AIRLINE_CONFIRMATION_NO: 'Airline confirmation no.',
    BRANDED_FARE: 'Branded fare',
    THIRD_PARTY_CONFIRMATION_NO: 'Third party confirmation no.',
    BAGGAGE: 'Baggage',
    PURCHASE: 'Purchase',
    ARC_BSP: 'ARC/BSP',
    LEG_BAGGAGE: 'Leg {{legNumber}}, baggage {{baggageNumber}}',
    LOWER_FARE_DECLINED: 'Lower fare declined',
    LOWER_FARE_DECLINED_CURRENCY: 'Lower fare declined currency',
    LOWER_FARE_DECLINED_AMOUNT: 'Lower fare declined amount',
    ADD_TAX_CODE: 'Add tax code',
    TAX_CODE: 'Tax code',
    NOT_APPLICABLE: 'Not applicable',
    LOYALTY_NUMBER: 'Loyalty number',
    LOYALTY_PROGRAM: 'Loyalty program',
    PROGRAM_NUMBER: 'Program number',
    NEW_BASE_FARE: 'New base fare',
    NEW_TAX: 'New taxes',
    SEAT_NUMBER: 'Seat number',
    OTHER_TRAVELERS_FORM_ISSUES: 'Please, check other travelers forms for issues',
    REASON: 'Reason',
    TAX_CODES_SUM_SHOULD_NOT_EXCEED_TAX: 'Tax codes amounts sum should not exceed tax amount',
    PAYMENT_METHOD_TO_USE: 'What payment method did you use to purchase the item?',
    CHARGING_METHOD_TO_USE: 'What should be the charging method for inventory booked?',
    DELAYED_INVOICE_PAYMENT_HELPER:
      'As the charge has already been paid using a TMC CC / TF Pay/ Check or Wire, and the org has not been set for delayed invoicing, you need to select which card should be charged for this trip from the list below. This card will be charged immediately for this travel item via Stripe, once the ‘Add booking’ button is selected.',
    DELAYED_INVOICE_TMC_PAYMENT_HELPER:
      'As you chose a TMC-issued card / TF Pay, Check or Wire above, and the legal entity is set up for delayed invoice, the client will be charged as part of their periodic invoice cycle. This travel item will be shown as part of the trip, once ‘Add booking’ is selected.',
    NON_TMC_PAYMENT_HELPER:
      'As the charge has already been paid using a traveler’s credit card or the client’s company credit card, no separate invoice will be generated. This travel item will be shown as part of the trip, once ‘Add booking’ is selected.',
    SHOULD_NOT_EXCEED: 'should not exceed',
    SEAT_IS_ALREADY_TAKEN: 'Seat is already taken',
    SHOULD_BE_UNIQUE: 'should be unique',
    EITHER_ALL_OR_NONE_TICKETS_SHOULD_HAVE_LLF:
      'Either all or none of the tickets should have lower fare declined info',
    OVERALL_PENALTY_CHARGED: 'Overall penalty charged',
  },
  SUPPORT: {
    GREETING: 'Hi {{userName}},',
    WE_ARE_HERE_TO_HELP: "We're here to help!",
    OUR_AGENTS_AVAILABLE_24_7: 'Our customer experience consultants are available 24/7 at your service.',
    REAL_PEOPLE_24_7: 'Real people, not chatbots - talk to our world-class travel agents 24/7',
    NEED_SOME_HELP: 'need some help?',
    CONTACT: 'Contact',
    AN_AGENT: 'an agent',
    LETS_CHAT: "Let's chat",
    CALL_US: 'Call us',
    WORLDS_BEST_AGENTS_24_7: 'The world’s best travel consultants are here for you 24/7.',
    OUR_PHONE_NUMBERS: 'Our phone numbers',
    TALK_TO_A_CONSULTANT: 'Talk to a consultant',
    CHAT_WITH_US: 'Chat with us',
    RETURN_TO_CHAT: 'Return to chat',
    SEE_HOW_TO_REPORT_A_BUG: 'See how to report a bug',
    SHAKE_YOUR_PHONE_IOS: 'Shake your phone or take a screenshot',
    SHAKE_YOUR_PHONE_ANDROID: 'Shake your phone',
    REPORT_A_BUG_TO_HELP_US: 'Report a bug to help us make the app even better for you.',
    GOOD_TO_GO: 'Good to go!',
  },
};

export default legacyTranslations;
